import React, { Fragment, useEffect } from "react";
import HeaderPortal from "../SlideHeader/HeaderPortal.js";
import HeaderShape from "../SlideHeader/HeaderShape";
import "./shape.css";
import FillColorEditComponent from "../SlideHeader/EditorComponents/FillColorEditComponent";
import { Exit, InsertTextInShape } from "../components/IconButtons/SubMenuIcons";
import StrokeColorEditComponent from "../SlideHeader/EditorComponents/StrokeColorEditComponent";
import BorderWeightEditComponent from "../SlideHeader/EditorComponents/BorderWeightEditComponent";
import BorderDashEditComponent from "../SlideHeader/EditorComponents/BorderDashEditComponent";
import SizeAndRotation from "../components/RightMenuComponents/SizeAndRotationComponent";
import Position from "../components/RightMenuComponents/PositionComponent";
import ListSubheader from "@mui/material/ListSubheader";
import { IconButton } from "@mui/material";
import List from "@mui/material/List";
import RightMenuPortal from "../components/Portals/RightMenuPortal.js";
import ButtonJ from "../components/Buttons/Button";
import HeaderMidPortal from "../components/Portals/HeaderMidPortal";

export const RGBAToHexA = (r, g, b, a) => {
  r = r.toString(16);
  g = g.toString(16);
  b = b.toString(16);
  a = Math.round(a * 255).toString(16);

  if (r.length == 1) r = "0" + r;
  if (g.length == 1) g = "0" + g;
  if (b.length == 1) b = "0" + b;
  if (a.length == 1) a = "0" + a;

  return "#" + r + g + b + a;
};

class ShapeObject extends React.Component {
  lastChanged = null;

  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: props.backgroundColor ? props.backgroundColor : "#999999",
      borderColor: props.borderColor ? props.borderColor : "#999999",
      borderWeight: props.borderWeight ? props.borderWeight : "0",
      borderDashed: props.borderDashed ? props.borderDashed : "0 0",
      bullet: props.bullet ? props.bullet : false,
      numbering: props.numbering ? props.numbering : false,
      currentBulletType: props.currentBulletType ? props.currentBulletType : "disc",
      currentNumberType: props.currentNumberType ? props.currentNumberType : "decimal",
      style: props.style
        ? props.style
        : {
            width: "100%",
            height: "100%",
            zIndex: 10000,
            pointerEvents: "auto",
            fontSize: "30px",
          },
      id: "shp_txt" + props.id,
      doubleClicked: false,
      value: props.value ? props.value : "",
      key: new Date().getTime(),
    };

    this.mainDiv = React.createRef();
    this.selected = props.selected;
    this.defaultFontSize = "14pt";
    this.rightMenuFunc = {};
    this.hasText = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 30, 88, 89, 90, 91, 92];

    this.lastChanged = this.createMarkup(this.state.value, true);

    global.pasteListener = this.handlePaste;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.multipleSeleced != this.props.multipleSeleced) {
      if (nextProps.multipleSeleced) {
        global.pasteListener = this.handlePaste;
      }
    }

    if (nextProps.selected != this.props.selected) {
      if (nextProps.selected) {
        global.pasteListener = this.handlePaste;
      }
    }

    return true;
  }

  handlePaste = (e) => {
    e.stopPropagation();

    if (!e.clipboardData.getData("text")) {
      return;
    }

    let text = e.clipboardData.getData("text");

    if (this.props.checkIfSlideObjects(e.clipboardData.getData("text"))) {
      e.preventDefault();
      this.props.slideComponentPaste(e, true);
      return;
    }

    if (!this.state.doubleClicked) {
      if (this.props.moreThanOneSelected) {
        e.preventDefault();
        this.props.slideComponentPaste(e, true);
      } else {
        e.preventDefault();
        this.setState({ value: text });
      }
    }
  };

  handleValueChange = (e, val) => {
    if (this.lastChanged != this.state.value) {
      this.setState({
        doubleClicked: false,
        key: "so_" + new Date().getTime(),
        value: this.lastChanged,
      });
      this.props.onPropsChange({ value: this.lastChanged });
    }
  };

  setBulletType = (type, curType) => {
    if (type === "number") {
      if (this.state.numbering && curType === this.state.currentNumberType) {
        this.setState({ currentNumberType: "decimal", numbering: false });
        this.props.onPropsChange({ numbering: false });
      } else {
        this.setState({ currentNumberType: curType, numbering: true, bullet: false });
        this.props.onPropsChange({ bullet: false, numbering: true, currentNumberType: curType });
      }
    } else if (type === "bullet") {
      if (this.state.bullet && curType === this.state.currentBulletType) {
        this.setState({ currentBulletType: "disc", bullet: false });
        this.props.onPropsChange({ bullet: false });
      } else {
        this.setState({ currentBulletType: curType, numbering: false, bullet: true });
        this.props.onPropsChange({ numbering: false, bullet: true });
      }
    }

    this.setState({ key: new Date().getTime() });
  };

  handleFillColorChange = (event) => {
    let rgba = event.backgroundColor.toString().slice(5).slice(0, -1).split(",");
    this.setState({
      backgroundColor: RGBAToHexA(
        Number(rgba[0]),
        Number(rgba[1]),
        Number(rgba[2]),
        Number(rgba[3]),
      ),
    });
    this.props.onPropsChange({
      backgroundColor: RGBAToHexA(
        Number(rgba[0]),
        Number(rgba[1]),
        Number(rgba[2]),
        Number(rgba[3]),
      ),
    });
  };

  handleBorderColorChange = (event) => {
    let rgba = event.backgroundColor.toString().slice(5).slice(0, -1).split(",");
    this.setState({
      borderColor: RGBAToHexA(Number(rgba[0]), Number(rgba[1]), Number(rgba[2]), Number(rgba[3])),
    });
    this.props.onPropsChange({
      borderColor: RGBAToHexA(Number(rgba[0]), Number(rgba[1]), Number(rgba[2]), Number(rgba[3])),
    });
  };

  changeStyles = (newStyle) => {
    const newObj = {};

    if (this.lastChanged != this.state.value) {
      this.props.onPropsChange({ value: this.lastChanged });
    }

    Object.assign(newObj, this.state.style);
    Object.assign(newObj, newStyle);
    this.setState({ style: newObj, value: this.lastChanged, key: "so_" + new Date().getTime() });
    this.props.onPropsChange({ style: newObj });
  };

  handleChangeBorderWeight = (obj) => {
    this.setState({ borderWeight: obj.borderWeight / 10 });
    this.props.onPropsChange({ borderWeight: obj.borderWeight / 10 });
  };

  handleChangeBorderDashed = (obj) => {
    this.setState({ borderDashed: obj.strokeStyle });
    this.props.onPropsChange({ borderDashed: obj.strokeStyle });
  };

  removeStyles = () => {
    this.setState({
      style: {
        width: "100%",
        height: "100%",
        zIndex: 10000,
        pointerEvents: "auto",
        fontSize: this.defaultFontSize,
      },
    });
    this.props.onPropsChange({
      style: {
        width: "100%",
        height: "100%",
        zIndex: 10000,
        pointerEvents: "auto",
        fontSize: this.defaultFontSize,
      },
    });
  };

  renderValue = (arr) => {
    // setKey(new Date().getTime())

    return arr.map((c, index) => {
      if (c) {
        return <div>{c}</div>;
      } else {
        return <br />;
      }
    });
  };

  renderBullet = (arr) => {
    return `<ul style={{listStyleType: ${this.state.currentBulletType}}} key=${new Date().getTime()}>${arr
      .map((c, index) => {
        return `<li key=${new Date().getTime() + index.toString()}>${c}</li>`;
      })
      .join("")
      .split(",")}</ul>`;
  };

  renderNumbering = (arr) => {
    return `<ol style={{listStyleType: ${this.state.currentNumberType}}}>${arr
      .map((c) => {
        return `<li>${c}</li>`;
      })
      .join("")
      .split(",")}</ol>`;
  };

  handleKeyDown = (e) => {
    switch (e.keyCode) {
      case 73:
        if (e.ctrlKey) {
          e.stopPropagation();
          e.preventDefault();
          // this.setStyle('fontStyle', 'italic', true)
        }
        break;
      case 66:
        if (e.ctrlKey) {
          e.stopPropagation();
          e.preventDefault();
          // this.setStyle('fontWeight', 'bold', true)
        }
        break;
      case 85:
        if (e.ctrlKey) {
          e.stopPropagation();
          e.preventDefault();
          // this.setStyle('textDecoration', 'underline', true)
        }
        break;
      case 90:
        if (e.ctrlKey) {
          if (this.state.value.trim() != e.target.innerText.trim()) {
            e.stopPropagation();
          } else {
            console.log("enters heree");
            e.preventDefault();
          }
        }
        break;
      default:
        e.stopPropagation();
    }
  };

  createMarkup = (val, html = false) => {
    if (!html) {
      if (val) {
        if (!this.state.bullet && !this.state.numbering) {
          return { __html: val };
        } else if (this.state.bullet) {
          if (val.indexOf("<ul") === -1) {
            const values = this.state.value.split("<div>");
            let finalValues = [];
            values.forEach((val) => {
              finalValues.push(val.replace("</div>", ""));
            });
            const html = this.renderBullet(finalValues);
            return { __html: html };
          } else {
            return { __html: val };
          }
        } else if (this.state.numbering) {
          if (val.indexOf("<ol") === -1) {
            const values = this.state.value.split("<div>");
            let finalValues = [];
            values.forEach((val) => {
              finalValues.push(val.replace("</div>", ""));
            });
            const html = this.renderNumbering(finalValues);
            return { __html: html };
          } else {
            return { __html: val };
          }
        }
      } else {
        return { __html: "" };
      }
    } else {
      return val;
    }
  };

  render() {
    return (
      <Fragment>
        {this.hasText.includes(this.props.shapeType) ? (
          <div
            className="shape_text_box"
            onMouseDown={(e) => {
              if (this.state.doubleClicked) e.stopPropagation();
            }}
            onKeyDown={this.handleKeyDown}
            onDoubleClick={() => {
              this.setState({ doubleClicked: true });
              document.getElementById(this.state.id).focus();
            }}
          >
            <div className="text_box_container">
              <div
                id={this.state.id}
                key={this.state.key}
                className={this.state.doubleClicked ? "text_box focused" : "text_box"}
                suppressContentEditableWarning
                contentEditable={true}
                onBlur={(e) => {
                  if (window.getSelection()) window.getSelection().removeAllRanges();
                  this.handleValueChange(e);
                  this.setState({ doubleClicked: false });
                }}
                ref={this.mainDiv}
                onMouseMove={(e) => {
                  if (this.state.doubleClicked) {
                    e.stopPropagation();
                    // e.preventDefault();
                  }
                }}
                onMouseDown={(e) => {
                  if (!this.state.doubleClicked) {
                    e.preventDefault();
                  }
                }}
                spellCheck={"true"}
                style={this.state.style}
                dangerouslySetInnerHTML={this.createMarkup(this.state.value)}
                onInput={(e) => {
                  this.lastChanged = e.target.innerHTML;
                }}
              />
              {/*</div>*/}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.props.selected && !this.props.multipleSelected && (
          <div
            onMouseDown={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
          >
            <HeaderMidPortal>
              <FillColorEditComponent
                onChange={(e) => this.handleFillColorChange(e)}
                style={{ backgroundColor: this.state.backgroundColor }}
              />
              <StrokeColorEditComponent
                onChange={(e) => this.handleBorderColorChange(e)}
                style={{ backgroundColor: this.state.borderColor }}
              />

              <BorderWeightEditComponent
                objType={"shapeObject"}
                onChange={this.handleChangeBorderWeight}
              />

              <BorderDashEditComponent
                objType={"shapeObject"}
                onChange={this.handleChangeBorderDashed}
              />

              <HeaderShape
                visible={true}
                style={this.state.style}
                onChange={this.changeStyles}
                toggleFormatOptions={this.props.toggleFormatOptions}
                onStyleRemove={this.removeStyles}
                setBulletType={this.setBulletType}
              />
            </HeaderMidPortal>
          </div>
        )}

        {this.props.formatOptions && this.props.selected && (
          <RightMenuPortal>
            <div className={"right_menu_mask"} onMouseDown={(e) => e.stopPropagation()}>
              <List
                style={{
                  paddingLeft: "0",
                  position: "absolute",
                  width: "100%",
                  height: "auto",
                  maxWidth: 250,
                  bgcolor: "background.paper",
                  paddingBottom: "0",
                  paddingTop: "0",
                  // overflow:'scroll',
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
                subheader={
                  <ListSubheader component="div" id="nested-list-subheader">
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: "16px",
                          textAlign: "left",
                        }}
                      >
                        Format Options
                      </span>
                      <IconButton onClick={this.props.toggleFormatOptions}>
                        <Exit />
                      </IconButton>
                    </div>
                  </ListSubheader>
                }
              >
                <SizeAndRotation
                  changeLockedAspect={this.props.changeLockedAspect}
                  onChange={this.props.onUpdateSizeAndRotation}
                  rightMenuFunc={this.rightMenuFunc}
                  lockedAspect={this.props.lockedAspect}
                  style={this.props.style}
                  width={this.props.width}
                  height={this.props.height}
                  rotateAngle={this.props.rotateAngle}
                  scaleX={this.props.scaleX}
                  scaleY={this.props.scaleY}
                />
                <Position
                  onChange={this.props.onUpdatePosition}
                  rightMenuFunc={this.rightMenuFunc}
                  style={this.props.style}
                  top={this.props.top}
                  left={this.props.left}
                />
              </List>
            </div>
          </RightMenuPortal>
        )}

        {this.props.shapeType === 1 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 3H2V21H22V3Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 2 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M18 3H6C3.79086 3 2 4.79086 2 7V17C2 19.2091 3.79086 21 6 21H18C20.2091 21 22 19.2091 22 17V7C22 4.79086 20.2091 3 18 3Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 3 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M2 21H22V10.2L13.8182 3H2V21Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {/*{this.props.shapeType === 4 && <svg className={'shape}  preserveAspectRatio="none"viewBox="1.5 2.5 21 19"mlns="http://www.w3.org/2000/svg">*/}
        {/*    <ellipse fill = {color} style={{border:'solid', borderColor: 'black'}} cx="100" cy="50" rx="100" ry="50" />*/}
        {/*</svg>}*/}
        {this.props.shapeType === 4 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M2 21H22V9.3L16.5455 3H7.45455L2 9.3V21Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}

        {this.props.shapeType === 5 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M9.27273 21H22V9.3L14.7273 3H2V14.7L9.27273 21Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 6 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M13.8182 3L14.1485 2.62464C14.0572 2.54431 13.9398 2.5 13.8182 2.5V3ZM22 21V21.5C22.2761 21.5 22.5 21.2761 22.5 21H22ZM2 21H1.5C1.5 21.2761 1.72386 21.5 2 21.5V21ZM22 10.2H22.5C22.5 10.0563 22.4382 9.91957 22.3303 9.82464L22 10.2ZM22 20.5H2V21.5H22V20.5ZM2.5 21V9H1.5V21H2.5ZM8 3.5H13.8182V2.5H8V3.5ZM13.4879 3.37536L21.6697 10.5754L22.3303 9.82464L14.1485 2.62464L13.4879 3.37536ZM21.5 10.2V21H22.5V10.2H21.5ZM2.5 9C2.5 5.96243 4.96243 3.5 8 3.5V2.5C4.41015 2.5 1.5 5.41015 1.5 9H2.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 7 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M2 3V2.5C1.72386 2.5 1.5 2.72386 1.5 3H2ZM22 21V21.5C22.2761 21.5 22.5 21.2761 22.5 21H22ZM2 21H1.5C1.5 21.2761 1.72386 21.5 2 21.5V21ZM2 3.5H14V2.5H2V3.5ZM21.5 11V21H22.5V11H21.5ZM22 20.5H2V21.5H22V20.5ZM2.5 21V3H1.5V21H2.5ZM14 3.5C18.1421 3.5 21.5 6.85786 21.5 11H22.5C22.5 6.30558 18.6944 2.5 14 2.5V3.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 8 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 21V21.5C22.2761 21.5 22.5 21.2761 22.5 21H22ZM2 21H1.5C1.5 21.2761 1.72386 21.5 2 21.5V21ZM10 3.5H14V2.5H10V3.5ZM21.5 11V21H22.5V11H21.5ZM22 20.5H2V21.5H22V20.5ZM2.5 21V11H1.5V21H2.5ZM14 3.5C18.1421 3.5 21.5 6.85786 21.5 11H22.5C22.5 6.30558 18.6944 2.5 14 2.5V3.5ZM10 2.5C5.30558 2.5 1.5 6.30558 1.5 11H2.5C2.5 6.85786 5.85786 3.5 10 3.5V2.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 9 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 3H22.5C22.5 2.72386 22.2761 2.5 22 2.5V3ZM2 21H1.5C1.5 21.2761 1.72386 21.5 2 21.5V21ZM10 3.5H22V2.5H10V3.5ZM21.5 3V13H22.5V3H21.5ZM14 20.5H2V21.5H14V20.5ZM2.5 21V11H1.5V21H2.5ZM21.5 13C21.5 17.1421 18.1421 20.5 14 20.5V21.5C18.6944 21.5 22.5 17.6944 22.5 13H21.5ZM10 2.5C5.30558 2.5 1.5 6.30558 1.5 11H2.5C2.5 6.85786 5.85786 3.5 10 3.5V2.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 10 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke={this.state.borderColor}
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
            />
          </svg>
        )}
        {this.props.shapeType === 11 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 22L2 22L12 2L22 22Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 12 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 22L2 22L2 2L22 22Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 13 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 3H7.45455L2 21H16.5455L22 3Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 14 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M18.3636 3H5.63636L2 21H22L18.3636 3Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 15 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 12L12 2L2 12L12 22L22 12Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 16 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M5.63636 22H18.3636L22 11.0909L12 2L2 11.0909L5.63636 22Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 17 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M7.45455 21H16.5455L22 12L16.5455 3H7.45455L2 12L7.45455 21Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M9.5 12.1895C9.5 9.39648 10.6377 8 12.9131 8C13.2712 8 13.5739 8.02767 13.8213 8.08301V9.04004C13.5739 8.96842 13.2874 8.93262 12.9619 8.93262C12.1969 8.93262 11.6224 9.1377 11.2383 9.54785C10.8542 9.95801 10.6458 10.6156 10.6133 11.5205H10.6719C10.8249 11.2568 11.0397 11.0534 11.3164 10.9102C11.5931 10.7637 11.9186 10.6904 12.293 10.6904C12.9408 10.6904 13.4453 10.889 13.8066 11.2861C14.168 11.6833 14.3486 12.222 14.3486 12.9023C14.3486 13.651 14.1387 14.2435 13.7188 14.6797C13.3021 15.1126 12.7324 15.3291 12.0098 15.3291C11.4987 15.3291 11.0544 15.207 10.6768 14.9629C10.2992 14.7155 10.0078 14.3574 9.80273 13.8887C9.60091 13.4167 9.5 12.8503 9.5 12.1895ZM11.9902 14.3818C12.3841 14.3818 12.6868 14.2549 12.8984 14.001C13.1133 13.7471 13.2207 13.3841 13.2207 12.9121C13.2207 12.502 13.1198 12.1797 12.918 11.9453C12.7194 11.7109 12.4199 11.5938 12.0195 11.5938C11.7721 11.5938 11.5443 11.6475 11.3359 11.7549C11.1276 11.859 10.9632 12.0039 10.8428 12.1895C10.7223 12.3717 10.6621 12.5589 10.6621 12.751C10.6621 13.21 10.7858 13.5973 11.0332 13.9131C11.2839 14.2256 11.6029 14.3818 11.9902 14.3818Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 18 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M7.45455 21H16.5455L22 12L16.5455 3H7.45455L2 12L7.45455 21Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M10.4189 15.5588L13.2412 9.44067H9.53027V8.42993H14.4668V9.23071L11.6592 15.5588H10.4189Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 19 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M7.45455 22H16.5455L22 16.5455V7.45455L16.5455 2H7.45455L2 7.45455V16.5455L7.45455 22Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M12.002 8.30005C12.679 8.30005 13.2145 8.4563 13.6084 8.7688C14.0023 9.07804 14.1992 9.49308 14.1992 10.0139C14.1992 10.7463 13.7598 11.329 12.8809 11.762C13.4408 12.0419 13.8379 12.3365 14.0723 12.6458C14.3099 12.955 14.4287 13.3 14.4287 13.6809C14.4287 14.2701 14.2122 14.7421 13.7793 15.0969C13.3464 15.4517 12.7604 15.6292 12.0215 15.6292C11.2467 15.6292 10.6462 15.4631 10.2197 15.1311C9.79329 14.7991 9.58008 14.3287 9.58008 13.72C9.58008 13.3228 9.69076 12.9664 9.91211 12.6506C10.1367 12.3316 10.5029 12.0484 11.0107 11.801C10.5745 11.5406 10.2637 11.2655 10.0781 10.9758C9.89258 10.6861 9.7998 10.3606 9.7998 9.99927C9.7998 9.48169 10.0033 9.06991 10.4102 8.76392C10.8171 8.45467 11.3477 8.30005 12.002 8.30005ZM10.6787 13.6809C10.6787 14.0194 10.7975 14.2831 11.0352 14.4719C11.2728 14.6575 11.5951 14.7502 12.002 14.7502C12.4219 14.7502 12.7474 14.6542 12.9785 14.4622C13.2129 14.2668 13.3301 14.0032 13.3301 13.6711C13.3301 13.4075 13.2227 13.1666 13.0078 12.9485C12.793 12.7304 12.4674 12.5286 12.0312 12.343L11.8896 12.2795C11.46 12.4683 11.1507 12.6767 10.9619 12.9045C10.7731 13.1292 10.6787 13.3879 10.6787 13.6809ZM11.9922 9.18384C11.6667 9.18384 11.4046 9.26522 11.2061 9.42798C11.0075 9.58748 10.9082 9.80558 10.9082 10.0823C10.9082 10.2515 10.944 10.4029 11.0156 10.5364C11.0872 10.6698 11.1914 10.7919 11.3281 10.9026C11.4648 11.01 11.696 11.1402 12.0215 11.2932C12.4121 11.1207 12.6872 10.94 12.8467 10.7512C13.0094 10.5592 13.0908 10.3362 13.0908 10.0823C13.0908 9.80558 12.9899 9.58748 12.7881 9.42798C12.5895 9.26522 12.3242 9.18384 11.9922 9.18384Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 20 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M7.45455 22H16.5455L22 16.5455V7.45455L16.5455 2H7.45455L2 7.45455V16.5455L7.45455 22Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M9.93652 15.551H8.78906V10.9417C8.78906 10.3915 8.80208 9.95532 8.82812 9.63306C8.75326 9.71118 8.66048 9.79744 8.5498 9.89185C8.44238 9.98625 8.0778 10.2857 7.45605 10.7903L6.87988 10.0627L8.97949 8.41235H9.93652V15.551Z"
              fill={this.state.borderColor}
            />
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M17.1191 11.9817C17.1191 13.2219 16.9189 14.1431 16.5186 14.7454C16.1214 15.3476 15.5127 15.6487 14.6924 15.6487C13.8981 15.6487 13.2959 15.3378 12.8857 14.7161C12.4756 14.0943 12.2705 13.1829 12.2705 11.9817C12.2705 10.7219 12.4691 9.79419 12.8662 9.19849C13.2666 8.59953 13.8753 8.30005 14.6924 8.30005C15.4899 8.30005 16.0938 8.61255 16.5039 9.23755C16.9141 9.86255 17.1191 10.7773 17.1191 11.9817ZM13.4326 11.9817C13.4326 12.955 13.5319 13.65 13.7305 14.0667C13.9323 14.4833 14.2529 14.6917 14.6924 14.6917C15.1318 14.6917 15.4525 14.4801 15.6543 14.0569C15.8594 13.6337 15.9619 12.942 15.9619 11.9817C15.9619 11.0247 15.8594 10.3329 15.6543 9.90649C15.4525 9.47681 15.1318 9.26196 14.6924 9.26196C14.2529 9.26196 13.9323 9.47192 13.7305 9.89185C13.5319 10.3118 13.4326 11.0084 13.4326 11.9817Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 21 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M7.45455 22H16.5455L22 16.5455V7.45455L16.5455 2H7.45455L2 7.45455V16.5455L7.45455 22Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M9.93652 15.551H8.78906V10.9417C8.78906 10.3915 8.80208 9.95532 8.82812 9.63306C8.75326 9.71118 8.66048 9.79744 8.5498 9.89185C8.44238 9.98625 8.0778 10.2857 7.45605 10.7903L6.87988 10.0627L8.97949 8.41235H9.93652V15.551Z"
              fill={this.state.borderColor}
            />
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M17.1191 11.9817C17.1191 13.2219 16.9189 14.1431 16.5186 14.7454C16.1214 15.3476 15.5127 15.6487 14.6924 15.6487C13.8981 15.6487 13.2959 15.3378 12.8857 14.7161C12.4756 14.0943 12.2705 13.1829 12.2705 11.9817C12.2705 10.7219 12.4691 9.79419 12.8662 9.19849C13.2666 8.59953 13.8753 8.30005 14.6924 8.30005C15.4899 8.30005 16.0938 8.61255 16.5039 9.23755C16.9141 9.86255 17.1191 10.7773 17.1191 11.9817ZM13.4326 11.9817C13.4326 12.955 13.5319 13.65 13.7305 14.0667C13.9323 14.4833 14.2529 14.6917 14.6924 14.6917C15.1318 14.6917 15.4525 14.4801 15.6543 14.0569C15.8594 13.6337 15.9619 12.942 15.9619 11.9817C15.9619 11.0247 15.8594 10.3329 15.6543 9.90649C15.4525 9.47681 15.1318 9.26196 14.6924 9.26196C14.2529 9.26196 13.9323 9.47192 13.7305 9.89185C13.5319 10.3118 13.4326 11.0084 13.4326 11.9817Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 22 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51808 6.3459 2.7612 8.17317C2.00433 10.0004 1.80629 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92893 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12H12L12 2Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 23 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12"
              stroke={this.state.borderColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 24 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              stroke={this.state.borderColor}
              d="M12 2L12.441 1.7643C12.354 1.60159 12.1845 1.5 12 1.5V2ZM20.3147 17.5557L20.7304 17.8335C20.8329 17.6801 20.8426 17.4827 20.7557 17.32L20.3147 17.5557ZM12 1.5C9.9233 1.5 7.89323 2.11581 6.16652 3.26957L6.72209 4.10104C8.28435 3.05717 10.1211 2.5 12 2.5V1.5ZM6.16652 3.26957C4.4398 4.42332 3.09399 6.0632 2.29927 7.98182L3.22315 8.36451C3.94218 6.62861 5.15982 5.14491 6.72209 4.10104L6.16652 3.26957ZM2.29927 7.98182C1.50455 9.90045 1.29661 12.0116 1.70176 14.0484L2.68254 13.8534C2.31598 12.0105 2.50412 10.1004 3.22315 8.36451L2.29927 7.98182ZM1.70176 14.0484C2.1069 16.0852 3.10693 17.9562 4.57538 19.4246L5.28249 18.7175C3.95389 17.3889 3.0491 15.6962 2.68254 13.8534L1.70176 14.0484ZM4.57538 19.4246C6.04383 20.8931 7.91476 21.8931 9.95156 22.2982L10.1466 21.3175C8.30383 20.9509 6.61109 20.0461 5.28249 18.7175L4.57538 19.4246ZM9.95156 22.2982C11.9884 22.7034 14.0996 22.4955 16.0182 21.7007L15.6355 20.7769C13.8996 21.4959 11.9895 21.684 10.1466 21.3175L9.95156 22.2982ZM16.0182 21.7007C17.9368 20.906 19.5767 19.5602 20.7304 17.8335L19.899 17.2779C18.8551 18.8402 17.3714 20.0578 15.6355 20.7769L16.0182 21.7007ZM20.7557 17.32L12.441 1.7643L11.559 2.2357L19.8737 17.7914L20.7557 17.32Z"
              fill={this.state.backgroundColor}
            />
          </svg>
        )}
        {this.props.shapeType === 25 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              stroke={this.state.borderColor}
              d="M22 2H22.5C22.5 1.72386 22.2761 1.5 22 1.5V2ZM11.0909 2.5H22V1.5H11.0909V2.5ZM21.5 2V12.9091H22.5V2H21.5ZM12.9091 21.5H11.0909V22.5H12.9091V21.5ZM11.0909 21.5C6.34628 21.5 2.5 17.6537 2.5 12.9091H1.5C1.5 18.206 5.794 22.5 11.0909 22.5V21.5ZM21.5 12.9091C21.5 17.6537 17.6537 21.5 12.9091 21.5V22.5C18.206 22.5 22.5 18.206 22.5 12.9091H21.5ZM11.0909 1.5C8.3773 1.5 5.97353 3.08801 4.26909 5.26338C2.56315 7.44066 1.5 10.2744 1.5 12.9091H2.5C2.5 10.523 3.47192 7.9022 5.05624 5.88013C6.64207 3.85615 8.78375 2.5 11.0909 2.5V1.5Z"
              fill={this.state.backgroundColor}
            />
          </svg>
        )}
        {this.props.shapeType === 26 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 3H2V21H22V3Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M19 6H5V18H19V6Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 27 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 2H2V12V22L7.45455 16.5455V7.45455H15.6364L22 2Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 28 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M10.1818 2H2V12V22H22V9.27273H10.1818V2Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 29 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M12 2L2 12V22L22 2H12Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 30 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 16.5455V12V7.45455H17V2H12H7V7.45455H2V12V16.5455H7V22H12H17V16.5455H22Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 31 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 16.5455V17.0455C22.2761 17.0455 22.5 16.8216 22.5 16.5455H22ZM17 22V22.5C17.2761 22.5 17.5 22.2761 17.5 22H17ZM7 22H6.5C6.5 22.2761 6.72386 22.5 7 22.5V22ZM2 16.5455H1.5C1.5 16.8216 1.72386 17.0455 2 17.0455V16.5455ZM2 7.45455V6.95455C1.72386 6.95455 1.5 7.1784 1.5 7.45455H2ZM7 2V1.5C6.72386 1.5 6.5 1.72386 6.5 2H7ZM17 2H17.5C17.5 1.72386 17.2761 1.5 17 1.5V2ZM22 7.45455H22.5C22.5 7.1784 22.2761 6.95455 22 6.95455V7.45455ZM16.5 21.5455V22H17.5V21.5455H16.5ZM7.5 22V21.5455H6.5V22H7.5ZM7.5 2.45454V2H6.5V2.45454H7.5ZM16.5 2V2.45454H17.5V2H16.5ZM7.5 21.5455C7.5 18.5079 5.03757 16.0455 2 16.0455V17.0455C4.48528 17.0455 6.5 19.0602 6.5 21.5455H7.5ZM22 16.0455C18.9624 16.0455 16.5 18.5079 16.5 21.5455H17.5C17.5 19.0602 19.5147 17.0455 22 17.0455V16.0455ZM16.5 2.45454C16.5 5.49211 18.9624 7.95455 22 7.95455V6.95455C19.5147 6.95455 17.5 4.93983 17.5 2.45454H16.5ZM2 7.95455C5.03757 7.95455 7.5 5.49211 7.5 2.45454H6.5C6.5 4.93983 4.48528 6.95455 2 6.95455V7.95455ZM21.5 7.45455V16.5455H22.5V7.45455H21.5ZM17 21.5H7V22.5H17V21.5ZM2.5 16.5455V7.45455H1.5V16.5455H2.5ZM7 2.5H17V1.5H7V2.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 32 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M2 5L1.6746 4.62037C1.56378 4.71536 1.5 4.85404 1.5 5H2ZM22 5H22.5C22.5 4.85404 22.4362 4.71536 22.3254 4.62037L22 5ZM2 19H1.5C1.5 19.1326 1.55268 19.2598 1.64645 19.3536L2 19ZM22 19L22.3536 19.3536C22.4473 19.2598 22.5 19.1326 22.5 19H22ZM12 21.5C8.57402 21.5 6.14537 20.7664 4.58453 20.046C3.80314 19.6854 3.23691 19.327 2.87028 19.063C2.68693 18.931 2.55347 18.8226 2.46797 18.7493C2.42523 18.7126 2.39447 18.6848 2.37548 18.6672C2.36598 18.6583 2.35943 18.6521 2.35578 18.6486C2.35396 18.6468 2.35287 18.6458 2.3525 18.6454C2.35231 18.6452 2.35231 18.6452 2.35248 18.6454C2.35257 18.6455 2.3527 18.6456 2.35288 18.6458C2.35297 18.6459 2.35314 18.646 2.35318 18.6461C2.35336 18.6463 2.35355 18.6464 2 19C1.64645 19.3536 1.64666 19.3538 1.64688 19.354C1.64697 19.3541 1.64721 19.3543 1.64739 19.3545C1.64775 19.3549 1.64816 19.3553 1.64862 19.3557C1.64953 19.3566 1.65062 19.3577 1.65191 19.359C1.65447 19.3615 1.65779 19.3647 1.66186 19.3686C1.66999 19.3765 1.68113 19.3871 1.69532 19.4002C1.72369 19.4265 1.76423 19.4631 1.81718 19.5085C1.92309 19.5993 2.07869 19.7253 2.28597 19.8745C2.70059 20.173 3.32186 20.5646 4.16547 20.954C5.85463 21.7336 8.42598 22.5 12 22.5V21.5ZM2.5 19V5H1.5V19H2.5ZM21.5 5V19H22.5V5H21.5ZM22 19C21.6464 18.6464 21.6466 18.6463 21.6468 18.6461C21.6469 18.646 21.647 18.6459 21.6471 18.6458C21.6473 18.6456 21.6474 18.6455 21.6475 18.6454C21.6477 18.6452 21.6477 18.6452 21.6475 18.6454C21.6471 18.6458 21.646 18.6468 21.6442 18.6486C21.6406 18.6521 21.634 18.6583 21.6245 18.6672C21.6055 18.6848 21.5748 18.7126 21.532 18.7493C21.4465 18.8226 21.3131 18.931 21.1297 19.063C20.7631 19.327 20.1969 19.6854 19.4155 20.046C17.8546 20.7664 15.426 21.5 12 21.5V22.5C15.574 22.5 18.1454 21.7336 19.8345 20.954C20.6781 20.5646 21.2994 20.173 21.714 19.8745C21.9213 19.7253 22.0769 19.5993 22.1828 19.5085C22.2358 19.4631 22.2763 19.4265 22.3047 19.4002C22.3189 19.3871 22.33 19.3765 22.3381 19.3686C22.3422 19.3647 22.3455 19.3615 22.3481 19.359C22.3494 19.3577 22.3505 19.3566 22.3514 19.3557C22.3518 19.3553 22.3522 19.3549 22.3526 19.3545C22.3528 19.3543 22.353 19.3541 22.3531 19.354C22.3533 19.3538 22.3536 19.3536 22 19ZM2 5C2.3254 5.37963 2.32524 5.37976 2.3251 5.37989C2.32506 5.37991 2.32493 5.38002 2.32487 5.38007C2.32475 5.38018 2.32468 5.38024 2.32467 5.38025C2.32464 5.38028 2.32482 5.38012 2.32521 5.37979C2.32599 5.37913 2.32761 5.37777 2.33008 5.37572C2.33501 5.37161 2.3433 5.36477 2.35494 5.35538C2.37822 5.33658 2.41489 5.30758 2.46481 5.2698C2.56466 5.19423 2.71748 5.08364 2.92227 4.9496C3.33191 4.68147 3.94896 4.31984 4.76557 3.95691C6.39785 3.23145 8.8289 2.5 12 2.5V1.5C8.6711 1.5 6.10215 2.26855 4.35943 3.04309C3.48854 3.43016 2.82434 3.81853 2.37461 4.1129C2.14971 4.26011 1.97831 4.38389 1.86136 4.47239C1.80289 4.51664 1.75801 4.55209 1.72685 4.57724C1.71127 4.58982 1.69911 4.59982 1.6904 4.60707C1.68604 4.6107 1.68255 4.61363 1.67992 4.61586C1.6786 4.61697 1.6775 4.6179 1.67661 4.61866C1.67617 4.61903 1.67578 4.61937 1.67545 4.61965C1.67528 4.61979 1.67507 4.61997 1.67498 4.62005C1.67479 4.62021 1.6746 4.62037 2 5ZM12 2.5C15.1711 2.5 17.6022 3.23145 19.2344 3.95691C20.051 4.31984 20.6681 4.68147 21.0777 4.9496C21.2825 5.08364 21.4353 5.19423 21.5352 5.2698C21.5851 5.30758 21.6218 5.33658 21.6451 5.35538C21.6567 5.36477 21.665 5.37161 21.6699 5.37572C21.6724 5.37777 21.674 5.37913 21.6748 5.37979C21.6752 5.38012 21.6754 5.38028 21.6753 5.38025C21.6753 5.38024 21.6752 5.38018 21.6751 5.38007C21.6751 5.38002 21.6749 5.37991 21.6749 5.37989C21.6748 5.37976 21.6746 5.37963 22 5C22.3254 4.62037 22.3252 4.62021 22.325 4.62005C22.3249 4.61997 22.3247 4.61979 22.3246 4.61965C22.3242 4.61937 22.3238 4.61903 22.3234 4.61866C22.3225 4.6179 22.3214 4.61697 22.3201 4.61586C22.3175 4.61363 22.314 4.6107 22.3096 4.60707C22.3009 4.59982 22.2887 4.58982 22.2732 4.57724C22.242 4.55209 22.1971 4.51664 22.1386 4.47239C22.0217 4.38389 21.8503 4.26011 21.6254 4.1129C21.1757 3.81853 20.5115 3.43016 19.6406 3.04309C17.8978 2.26855 15.3289 1.5 12 1.5V2.5ZM2 5C1.6746 5.37963 1.67479 5.37979 1.67498 5.37995C1.67507 5.38003 1.67528 5.38021 1.67545 5.38035C1.67578 5.38063 1.67617 5.38097 1.67661 5.38134C1.6775 5.3821 1.6786 5.38303 1.67992 5.38414C1.68255 5.38637 1.68604 5.3893 1.6904 5.39293C1.69911 5.40018 1.71127 5.41018 1.72685 5.42276C1.75801 5.44791 1.80289 5.48336 1.86136 5.52761C1.97831 5.61611 2.14971 5.73989 2.37461 5.8871C2.82434 6.18147 3.48854 6.56984 4.35943 6.95691C6.10215 7.73145 8.6711 8.5 12 8.5V7.5C8.8289 7.5 6.39785 6.76855 4.76557 6.04309C3.94896 5.68016 3.33191 5.31853 2.92227 5.0504C2.71748 4.91636 2.56466 4.80577 2.46481 4.7302C2.41489 4.69242 2.37822 4.66342 2.35494 4.64462C2.3433 4.63523 2.33501 4.62839 2.33008 4.62428C2.32761 4.62223 2.32599 4.62087 2.32521 4.62021C2.32482 4.61988 2.32464 4.61972 2.32467 4.61975C2.32468 4.61976 2.32475 4.61982 2.32487 4.61993C2.32493 4.61998 2.32506 4.62009 2.3251 4.62011C2.32524 4.62024 2.3254 4.62037 2 5ZM12 8.5C15.3289 8.5 17.8978 7.73145 19.6406 6.95691C20.5115 6.56984 21.1757 6.18147 21.6254 5.8871C21.8503 5.73989 22.0217 5.61611 22.1386 5.52761C22.1971 5.48336 22.242 5.44791 22.2732 5.42276C22.2887 5.41018 22.3009 5.40018 22.3096 5.39293C22.314 5.3893 22.3175 5.38637 22.3201 5.38414C22.3214 5.38303 22.3225 5.3821 22.3234 5.38134C22.3238 5.38097 22.3242 5.38063 22.3246 5.38035C22.3247 5.38021 22.3249 5.38003 22.325 5.37995C22.3252 5.37979 22.3254 5.37963 22 5C21.6746 4.62037 21.6748 4.62024 21.6749 4.62011C21.6749 4.62009 21.6751 4.61998 21.6751 4.61993C21.6752 4.61982 21.6753 4.61976 21.6753 4.61975C21.6754 4.61972 21.6752 4.61988 21.6748 4.62021C21.674 4.62087 21.6724 4.62223 21.6699 4.62428C21.665 4.62839 21.6567 4.63523 21.6451 4.64462C21.6218 4.66342 21.5851 4.69242 21.5352 4.7302C21.4353 4.80577 21.2825 4.91636 21.0777 5.0504C20.6681 5.31853 20.051 5.68016 19.2344 6.04309C17.6022 6.76855 15.1711 7.5 12 7.5V8.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 33 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M2 6L6.5 2H22M2 6H18M2 6V22H18M22 2V11V16L18 22M22 2L18 6M18 22V6"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 34 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51472 16.5 7.5 14.4853 7.5 12ZM12 6.5C8.96243 6.5 6.5 8.96243 6.5 12C6.5 15.0376 8.96243 17.5 12 17.5C15.0376 17.5 17.5 15.0376 17.5 12C17.5 8.96243 15.0376 6.5 12 6.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 35 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM18.1918 13.9839L8.64577 6.43109C9.62486 5.83999 10.7722 5.5 12 5.5C15.5899 5.5 18.5 8.41015 18.5 12C18.5 12.6924 18.3919 13.3589 18.1918 13.9839ZM12 4.5C10.3122 4.5 8.75325 5.05814 7.49971 5.9997L6.98116 6.3892L7.48976 6.7916L18.1073 15.1921L18.616 15.5946L18.8757 15.0002C19.2774 14.0808 19.5 13.0657 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5ZM5.8927 8.80789L5.38399 8.4054L5.12428 8.99981C4.72259 9.9192 4.5 10.9343 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C13.6878 19.5 15.2468 18.9419 16.5003 18.0003L17.0188 17.6108L16.5102 17.2084L5.8927 8.80789ZM5.5 12C5.5 11.3076 5.60811 10.6411 5.80817 10.0161L15.3542 17.5689C14.3751 18.16 13.2278 18.5 12 18.5C8.41015 18.5 5.5 15.5899 5.5 12Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 36 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C4.00035 5.85752 3.26375 6.95991 2.7612 8.17317C2.25866 9.38642 2 10.6868 2 12L7 12C7 11.3434 7.12933 10.6932 7.3806 10.0866C7.63188 9.47996 8.00017 8.92876 8.46447 8.46447C8.92876 8.00017 9.47995 7.63188 10.0866 7.3806C10.6932 7.12933 11.3434 7 12 7C12.6566 7 13.3068 7.12933 13.9134 7.3806C14.52 7.63188 15.0712 8.00017 15.5355 8.46447C15.9998 8.92876 16.3681 9.47995 16.6194 10.0866C16.8707 10.6932 17 11.3434 17 12H22Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 37 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M14 22H3V2H21V15M14 22V15H21M14 22L21 15"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 38 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM7.67499 13.963C7.57905 13.704 7.29137 13.5719 7.03243 13.6678C6.77348 13.7638 6.64134 14.0514 6.73728 14.3104C7.08696 15.2542 7.79775 16.0605 8.73802 16.6259C9.678 17.1912 10.8091 17.4939 11.9649 17.4999C13.1206 17.5059 14.2562 17.215 15.2046 16.6599C16.1533 16.1048 16.8764 15.3067 17.2411 14.3674C17.341 14.11 17.2134 13.8203 16.9559 13.7204C16.6985 13.6204 16.4088 13.7481 16.3089 14.0055C16.0373 14.7051 15.4822 15.3388 14.6995 15.7969C13.9166 16.255 12.9594 16.5051 11.9701 16.4999C10.9807 16.4948 10.0281 16.2348 9.25336 15.7689C8.4789 15.3032 7.93489 14.6645 7.67499 13.963ZM7.5 9.5C7.5 8.94772 7.94772 8.5 8.5 8.5C9.05228 8.5 9.5 8.94772 9.5 9.5C9.5 10.0523 9.05228 10.5 8.5 10.5C7.94772 10.5 7.5 10.0523 7.5 9.5ZM15.5 8.5C14.9477 8.5 14.5 8.94772 14.5 9.5C14.5 10.0523 14.9477 10.5 15.5 10.5C16.0523 10.5 16.5 10.0523 16.5 9.5C16.5 8.94772 16.0523 8.5 15.5 8.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 39 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M12.0063 21L3.51888 12.709C-1.09384 7.73443 5.68686 -1.81677 12.0063 5.91042C18.3257 -1.81677 25.0757 7.7676 20.4937 12.709L12.0063 21Z"
              stroke={this.state.borderColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 40 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M7.64886 2L4.05983 10.1692C4.01019 10.2858 3.99099 10.4123 4.00391 10.5377C4.01684 10.663 4.06149 10.7834 4.13395 10.8882C4.20641 10.9931 4.30446 11.0791 4.41948 11.1389C4.53449 11.1986 4.66296 11.2301 4.79359 11.2308H9.24398L6.05374 22L19.7558 9.47692C19.8697 9.37115 19.9483 9.23514 19.9819 9.08616C20.0154 8.93718 20.0023 8.78196 19.9441 8.64019C19.886 8.49842 19.7856 8.3765 19.6555 8.28991C19.5254 8.20332 19.3715 8.15596 19.2135 8.15385L13.2318 8.15385L16.422 2L7.64886 2Z"
              stroke={this.state.borderColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 41 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1 1 22 22"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.998 1C12.2742 1 12.498 1.22386 12.498 1.5V4.73008C12.498 5.00623 12.2742 5.23008 11.998 5.23008C11.7219 5.23008 11.498 5.00623 11.498 4.73008V1.5C11.498 1.22386 11.7219 1 11.998 1ZM11.9986 8.46026C10.0448 8.46026 8.461 10.0441 8.461 11.9979C8.461 13.9516 10.0448 15.5355 11.9986 15.5355C13.9523 15.5355 15.5361 13.9516 15.5361 11.9979C15.5361 10.0441 13.9523 8.46026 11.9986 8.46026ZM7.461 11.9979C7.461 9.49182 9.49253 7.46026 11.9986 7.46026C14.5046 7.46026 16.5361 9.49182 16.5361 11.9979C16.5361 14.5039 14.5046 16.5355 11.9986 16.5355C9.49253 16.5355 7.461 14.5039 7.461 11.9979ZM4.92094 4.21505C4.72568 4.01979 4.40909 4.01979 4.21383 4.21505C4.01857 4.41031 4.01857 4.72689 4.21383 4.92215L6.50796 7.21632C6.70322 7.41158 7.0198 7.41158 7.21507 7.21632C7.41033 7.02106 7.41033 6.70448 7.21507 6.50921L4.92094 4.21505ZM1 11.9977C1 11.7215 1.22386 11.4977 1.5 11.4977H4.73004C5.00619 11.4977 5.23004 11.7215 5.23004 11.9977C5.23004 12.2738 5.00619 12.4977 4.73004 12.4977H1.5C1.22386 12.4977 1 12.2738 1 11.9977ZM7.21507 17.4871C7.41033 17.2918 7.41033 16.9753 7.21507 16.78C7.0198 16.5847 6.70322 16.5847 6.50796 16.78L4.21383 19.0742C4.01857 19.2694 4.01857 19.586 4.21383 19.7813C4.40909 19.9765 4.72568 19.9765 4.92094 19.7813L7.21507 17.4871ZM11.998 18.7654C12.2742 18.7654 12.498 18.9892 12.498 19.2654V22.4955C12.498 22.7716 12.2742 22.9955 11.998 22.9955C11.7219 22.9955 11.498 22.7716 11.498 22.4955V19.2654C11.498 18.9892 11.7219 18.7654 11.998 18.7654ZM17.4883 16.78C17.2931 16.5847 16.9765 16.5847 16.7812 16.78C16.586 16.9753 16.5859 17.2918 16.7812 17.4871L19.0753 19.7813C19.2706 19.9765 19.5872 19.9765 19.7825 19.7813C19.9777 19.586 19.9777 19.2694 19.7825 19.0742L17.4883 16.78ZM18.7656 11.9976C18.7656 11.7214 18.9895 11.4976 19.2656 11.4976H22.4957C22.7718 11.4976 22.9957 11.7214 22.9957 11.9976C22.9957 12.2737 22.7718 12.4976 22.4957 12.4976H19.2656C18.9895 12.4976 18.7656 12.2737 18.7656 11.9976ZM19.7825 4.92215C19.9777 4.72689 19.9777 4.41031 19.7825 4.21505C19.5872 4.01979 19.2706 4.01979 19.0753 4.21505L16.7812 6.50921C16.5859 6.70448 16.586 7.02106 16.7812 7.21632C16.9765 7.41158 17.2931 7.41158 17.4883 7.21632L19.7825 4.92215Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 42 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M13.5842 12C13.5915 10.1348 14.0902 8.30348 15.0314 6.68536C15.9725 5.06723 17.3239 3.71781 18.9532 2.76923C17.745 2.27618 16.4524 2.01509 15.1449 2C12.4543 2 9.87392 3.05357 7.97138 4.92893C6.06884 6.8043 5 9.34784 5 12C5 14.6522 6.06884 17.1957 7.97138 19.0711C9.87392 20.9464 12.4543 22 15.1449 22C16.4682 21.9908 17.7773 21.7296 19 21.2308C17.362 20.2879 16.0013 18.941 15.0517 17.3225C14.1021 15.704 13.5963 13.8697 13.5842 12V12Z"
              stroke={this.state.borderColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 43 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M18.3059 10.0248C18.0534 10.0028 17.799 10.0028 17.5465 10.0248C17.269 8.88399 16.5677 7.86303 15.559 7.13104C14.5502 6.39906 13.2945 6 12 6C10.7055 6 9.44978 6.39906 8.44104 7.13104C7.43229 7.86303 6.73103 8.88399 6.45348 10.0248C6.20094 10.0028 5.94667 10.0028 5.69412 10.0248C5.09153 9.99151 4.48778 10.0699 3.92001 10.2551C3.35224 10.4402 2.8325 10.7283 2.39277 11.1015C1.95304 11.4747 1.60262 11.9251 1.36309 12.4251C1.12357 12.9251 1 13.464 1 14.0087C1 14.5533 1.12357 15.0922 1.36309 15.5922C1.60262 16.0922 1.95304 16.5427 2.39277 16.9158C2.8325 17.289 3.35224 17.5771 3.92001 17.7623C4.48778 17.9475 5.09153 18.0258 5.69412 17.9925H18.3059C18.9085 18.0258 19.5122 17.9475 20.0799 17.7623C20.6477 17.5771 21.1676 17.289 21.6072 16.9158C22.0469 16.5427 22.3974 16.0922 22.6368 15.5922C22.8765 15.0922 23 14.5533 23 14.0087C23 13.464 22.8765 12.9251 22.6368 12.4251C22.3974 11.9251 22.0469 11.4747 21.6072 11.1015C21.1676 10.7283 20.6477 10.4402 20.0799 10.2551C19.5122 10.0699 18.9085 9.99151 18.3059 10.0248Z"
              stroke={this.state.borderColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 44 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 12.2593L12 5L2 12.2593L12 19L22 12.2593Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 45 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M5 3H2V21H5M5 3V21M5 3H19M5 21H19M19 3H22V21H19M19 3V21"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 46 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M5 3H2V6M5 3V21M5 3H19H22V6M5 21H2V6M5 21H19H22V6M2 6H22"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 47 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M2 2V1.5C1.72386 1.5 1.5 1.72386 1.5 2H2ZM22 2H22.5C22.5 1.72386 22.2761 1.5 22 1.5V2ZM22 18L21.7227 18.416C21.8761 18.5183 22.0734 18.5278 22.2359 18.4408C22.3985 18.3538 22.5 18.1844 22.5 18H22ZM2 20H1.5C1.5 20.2045 1.62448 20.3883 1.8143 20.4642L2 20ZM20.8282 17.2188L20.5509 17.6348L20.8282 17.2188ZM7.43768 21.7082L7.71503 22.1242L7.43768 21.7082ZM2 2.5H22V1.5H2V2.5ZM21.5 2V18H22.5V2H21.5ZM2.5 20V2H1.5V20H2.5ZM6.69729 21.3404L2.1857 19.5358L1.8143 20.4642L6.3259 22.2689L6.69729 21.3404ZM22.2773 17.584L21.1056 16.8028L20.5509 17.6348L21.7227 18.416L22.2773 17.584ZM13.8944 16.8028L7.16033 21.2922L7.71503 22.1242L14.4491 17.6348L13.8944 16.8028ZM21.1056 16.8028C18.9222 15.3472 16.0778 15.3472 13.8944 16.8028L14.4491 17.6348C16.2966 16.4032 18.7034 16.4032 20.5509 17.6348L21.1056 16.8028ZM6.3259 22.2689C6.78451 22.4523 7.30405 22.3982 7.71503 22.1242L7.16033 21.2922C7.02334 21.3835 6.85016 21.4015 6.69729 21.3404L6.3259 22.2689Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 48 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="2 2 20 20"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.83318 2C8.55704 2 8.33318 2.22386 8.33318 2.5V4.11084H6.7231C6.44696 4.11084 6.2231 4.3347 6.2231 4.61084V6.22168H4.61204C4.3359 6.22168 4.11204 6.44554 4.11204 6.72168V8.33228H2.50098C2.22483 8.33228 2.00098 8.55613 2.00098 8.83228V17.6426C2.00098 17.8171 2.09195 17.979 2.24101 18.0697L8.57357 21.9243C8.73326 22.0215 8.93383 22.0215 9.09351 21.9243L15.4261 18.0697C15.5751 17.979 15.6661 17.8171 15.6661 17.6426V16.7204H17.2772C17.5533 16.7204 17.7772 16.4965 17.7772 16.2204V14.6095H19.3882C19.6644 14.6095 19.8882 14.3857 19.8882 14.1095V12.4987H21.4983C21.7745 12.4987 21.9983 12.2748 21.9983 11.9987V2.5C21.9983 2.22386 21.7745 2 21.4983 2H8.83318ZM19.8882 11.4987H20.9983V3H9.33318V4.11084H19.3882C19.6644 4.11084 19.8882 4.3347 19.8882 4.61084V11.4987ZM18.8882 13.6095H17.7772V6.72168C17.7772 6.44554 17.5533 6.22168 17.2772 6.22168H7.2231V5.11084H18.8882V13.6095ZM15.6661 15.7204H16.7772V7.22168H5.11204V8.33228H15.1661C15.4423 8.33228 15.6661 8.55613 15.6661 8.83228V15.7204ZM3.00098 17.3616V9.33228H14.6661V17.3616L8.83354 20.9118L3.00098 17.3616Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 49 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M18 7H6C3.79086 7 2 8.79086 2 11V13C2 15.2091 3.79086 17 6 17H18C20.2091 17 22 15.2091 22 13V11C22 8.79086 20.2091 7 18 7Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 50 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M7.45455 18H16.5455L22 12L16.5455 6H7.45455L2 12L7.45455 18Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 51 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 17"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 3L2 12.4118V19H22V3Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 52 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 17"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M20 3H4L6.26087 19H17.7391L20 3Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 53 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="3.5 3.5 17 17"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="8" stroke={this.state.borderColor} />
          </svg>
        )}
        {this.props.shapeType === 54 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="2.5 2.5 19 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.5 3C2.5 2.72386 2.72386 2.5 3 2.5H21C21.2761 2.5 21.5 2.72386 21.5 3V15.5217C21.5 15.6962 21.409 15.8581 21.26 15.9488L12.26 21.4271C12.1003 21.5243 11.8997 21.5243 11.74 21.4271L2.74003 15.9488C2.59097 15.8581 2.5 15.6962 2.5 15.5217V3ZM3.5 3.5V15.2407L12 20.4147L20.5 15.2407V3.5H3.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 55 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="2.5 2.5 19 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.1588 2.63447C10.2514 2.54806 10.3734 2.5 10.5 2.5H21C21.2761 2.5 21.5 2.72386 21.5 3V21C21.5 21.2761 21.2761 21.5 21 21.5H3C2.72386 21.5 2.5 21.2761 2.5 21V10C2.5 9.86141 2.55752 9.72904 2.65884 9.63447L10.1588 2.63447ZM10.6971 3.5L3.5 10.2173V20.5H20.5V3.5H10.6971Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 56 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="2.5 2.5 19 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.2092 4.83566C10.7072 5.59862 9.06955 6.40566 6.90875 6.00459C6.03343 5.84212 4.99238 5.45254 4.19156 5.11643C3.93609 5.0092 3.70151 4.90588 3.5 4.81465V18.6273C3.54543 18.6569 3.59731 18.6904 3.65498 18.7272C3.89167 18.8782 4.22466 19.0836 4.60905 19.3011C5.38976 19.7427 6.33822 20.208 7.11484 20.3913C8.88509 20.809 10.21 19.963 11.7226 18.904C11.785 18.8603 11.8477 18.8162 11.9108 18.7719C13.3248 17.7784 14.9327 16.6485 17.0615 16.9122C18.0494 17.0346 19.1031 17.4302 19.8888 17.78C20.1139 17.8802 20.32 17.978 20.5 18.0668V4.388C20.4833 4.38265 20.4661 4.37714 20.4483 4.37148C20.2023 4.29307 19.8577 4.18674 19.4641 4.07526C18.6692 3.85009 17.7032 3.61227 16.9472 3.53198C15.15 3.3411 13.7862 4.03424 12.2973 4.79092C12.268 4.80581 12.2386 4.82073 12.2092 4.83566ZM21 4.02606L21.1619 3.55301C21.3641 3.62223 21.5 3.81233 21.5 4.02606V18.8953C21.5 19.0742 21.4045 19.2394 21.2495 19.3286C21.0946 19.4178 20.9038 19.4175 20.7492 19.3279L20.7491 19.3278C20.7491 19.3278 20.7491 19.3278 20.7491 19.3278C20.7491 19.3278 20.7491 19.3278 20.749 19.3278L20.7484 19.3274L20.7447 19.3253L20.7283 19.3159C20.7133 19.3074 20.6906 19.2946 20.6607 19.278C20.6008 19.2448 20.5122 19.1966 20.3999 19.1377C20.175 19.0198 19.8561 18.8601 19.4821 18.6936C18.7248 18.3564 17.7785 18.0087 16.9385 17.9046C15.1994 17.6892 13.8861 18.6093 12.392 19.656C12.3601 19.6783 12.3282 19.7007 12.2962 19.7231C10.815 20.7601 9.13996 21.8966 6.88516 21.3645C5.96279 21.1469 4.91124 20.6209 4.1167 20.1715C3.71347 19.9434 3.36502 19.7284 3.11718 19.5703C2.99313 19.4911 2.89397 19.4261 2.82539 19.3805C2.79109 19.3577 2.76442 19.3397 2.74609 19.3273L2.72492 19.3129L2.71918 19.309L2.71756 19.3079L2.71706 19.3076L2.71689 19.3075C2.71683 19.3074 2.71677 19.3074 3 18.8953L2.71677 19.3074C2.58107 19.2141 2.5 19.06 2.5 18.8953V4.02606C2.5 3.8527 2.5898 3.69171 2.73731 3.60063C2.88481 3.50956 3.06895 3.50138 3.22393 3.57901L3.22394 3.57901L3.22398 3.57904L3.2241 3.5791L3.22508 3.57958L3.22955 3.58181L3.24832 3.59112C3.26512 3.59941 3.29033 3.6118 3.32322 3.62779C3.38901 3.65977 3.48541 3.7061 3.60645 3.76279C3.84873 3.87625 4.18867 4.0307 4.57857 4.19435C5.3678 4.5256 6.32675 4.87949 7.09125 5.02139C8.88712 5.35472 10.2483 4.7101 11.7564 3.94408C11.8071 3.91834 11.8579 3.89245 11.909 3.86646C13.3556 3.13007 14.9568 2.31496 17.0528 2.53757C17.8978 2.62732 18.9319 2.88515 19.7366 3.11311C20.1429 3.22819 20.4981 3.3378 20.752 3.41869C20.879 3.45917 20.9808 3.49251 21.0512 3.51585L21.1324 3.54301L21.1539 3.55029L21.1597 3.55224L21.1612 3.55277L21.1617 3.55293L21.1618 3.55298L21 4.02606Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 57 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M4.5 5.38544C2.94409 7.14827 2 9.46388 2 12C2 14.7974 3.14864 17.3265 5 19.1414M4.5 5.38544C6.33236 3.30939 9.01327 2 12 2C14.9867 2 17.6676 3.30939 19.5 5.38544M4.5 5.38544L19 19.1414M19 19.1414C20.8514 17.3265 22 14.7974 22 12C22 9.46388 21.0559 7.14827 19.5 5.38544M19 19.1414C17.1962 20.9097 14.7255 22 12 22C9.27455 22 6.80375 20.9097 5 19.1414M19.5 5.38544L5 19.1414"
              stroke={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 58 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12H2M12 22C6.47715 22 2 17.5228 2 12M12 22V2M2 12C2 6.47715 6.47715 2 12 2"
              stroke={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 59 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="2.5 2.5 19 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.53806 2.80866C2.61545 2.62182 2.79777 2.5 3 2.5H21C21.2022 2.5 21.3846 2.62182 21.4619 2.80866C21.5393 2.9955 21.4966 3.21055 21.3536 3.35355L12.7071 12L21.3536 20.6464C21.4966 20.7894 21.5393 21.0045 21.4619 21.1913C21.3846 21.3782 21.2022 21.5 21 21.5H12H3C2.79777 21.5 2.61545 21.3782 2.53806 21.1913C2.46067 21.0045 2.50345 20.7894 2.64645 20.6464L11.2929 12L2.64645 3.35355C2.50345 3.21055 2.46067 2.9955 2.53806 2.80866ZM12 11.2929L19.7929 3.5H4.20711L12 11.2929ZM12 12.7071L4.20711 20.5H12H19.7929L12 12.7071Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 60 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="2.5 1.5 19 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.0003 1.5C12.1421 1.5 12.2772 1.56016 12.372 1.66552L21.372 11.6655C21.5431 11.8557 21.5431 12.1443 21.372 12.3345L12.372 22.3345C12.2772 22.4398 12.1421 22.5 12.0003 22.5C11.8586 22.5 11.7235 22.4398 11.6287 22.3345L2.62836 12.3345C2.45721 12.1443 2.45721 11.8557 2.62836 11.6655L11.6287 1.66551C11.7235 1.56016 11.8586 1.5 12.0003 1.5ZM4.12271 12.5L12.0003 21.2526L19.8777 12.5H4.12271ZM19.8777 11.5H4.12271L12.0003 2.74742L19.8777 11.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === -1 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 21L2 21L12 3L22 21Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 61 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M12 21L2 3L22 3L12 21Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 62 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="3.5 2.5 17 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M20 3L20.3723 3.33373C20.504 3.18684 20.537 2.97625 20.4565 2.79612C20.3761 2.61599 20.1973 2.5 20 2.5L20 3ZM20 21L20 21.5C20.1973 21.5 20.3761 21.384 20.4565 21.2039C20.537 21.0238 20.504 20.8132 20.3723 20.6663L20 21ZM6.82353 3L6.82353 2.5C6.69479 2.5 6.57101 2.54966 6.47797 2.63863L6.82353 3ZM6.82353 21L6.47797 21.3614C6.57101 21.4503 6.69479 21.5 6.82353 21.5L6.82353 21ZM4.5 12C4.5 8.92764 5.18784 6.75173 5.86206 5.35484C6.19968 4.65532 6.53509 4.14871 6.78179 3.82106C6.90515 3.65722 7.00634 3.53812 7.07453 3.46205C7.10862 3.42402 7.13445 3.39675 7.15066 3.38004C7.15877 3.37169 7.16447 3.36597 7.1676 3.36287C7.16917 3.36131 7.17009 3.36042 7.17034 3.36017C7.17047 3.36004 7.17043 3.36008 7.17022 3.36028C7.17012 3.36038 7.16997 3.36052 7.16978 3.3607C7.16969 3.36079 7.16952 3.36096 7.16947 3.36101C7.16928 3.36118 7.16909 3.36137 6.82353 3C6.47797 2.63863 6.47775 2.63884 6.47753 2.63905C6.47744 2.63914 6.4772 2.63937 6.47702 2.63954C6.47666 2.63989 6.47625 2.64028 6.47581 2.64071C6.47492 2.64157 6.47385 2.6426 6.47262 2.64379C6.47017 2.64619 6.46704 2.64926 6.46326 2.65301C6.4557 2.66051 6.44555 2.67072 6.43297 2.68368C6.40783 2.70959 6.373 2.74649 6.32989 2.79459C6.24366 2.89078 6.12426 3.03184 5.98292 3.21956C5.7002 3.59504 5.32973 4.15718 4.96147 4.92016C4.22392 6.44827 3.5 8.77236 3.5 12L4.5 12ZM6.82353 3.5L20 3.5L20 2.5L6.82353 2.5L6.82353 3.5ZM20 20.5L6.82353 20.5L6.82353 21.5L20 21.5L20 20.5ZM6.82353 21C7.16909 20.6386 7.16928 20.6388 7.16947 20.639C7.16951 20.639 7.16969 20.6392 7.16978 20.6393C7.16997 20.6395 7.17012 20.6396 7.17022 20.6397C7.17043 20.6399 7.17047 20.64 7.17034 20.6398C7.17009 20.6396 7.16917 20.6387 7.1676 20.6371C7.16447 20.634 7.15877 20.6283 7.15066 20.62C7.13445 20.6032 7.10862 20.576 7.07453 20.5379C7.00634 20.4619 6.90515 20.3428 6.78179 20.1789C6.53509 19.8513 6.19968 19.3447 5.86206 18.6452C5.18784 17.2483 4.5 15.0724 4.5 12L3.5 12C3.5 15.2276 4.22392 17.5517 4.96147 19.0798C5.32973 19.8428 5.7002 20.405 5.98292 20.7804C6.12426 20.9682 6.24366 21.1092 6.32988 21.2054C6.373 21.2535 6.40783 21.2904 6.43297 21.3163C6.44555 21.3293 6.4557 21.3395 6.46326 21.347C6.46703 21.3507 6.47016 21.3538 6.47262 21.3562C6.47385 21.3574 6.47491 21.3584 6.47581 21.3593C6.47625 21.3597 6.47666 21.3601 6.47702 21.3605C6.4772 21.3606 6.47743 21.3609 6.47752 21.3609C6.47775 21.3612 6.47797 21.3614 6.82353 21ZM20 3C19.6277 2.66627 19.6275 2.66645 19.6273 2.66664C19.6273 2.66672 19.6271 2.66692 19.6269 2.66708C19.6267 2.66741 19.6263 2.66778 19.626 2.66819C19.6252 2.66903 19.6243 2.67006 19.6232 2.67129C19.6211 2.67374 19.6182 2.67697 19.6147 2.68097C19.6078 2.68898 19.5982 2.70009 19.5862 2.71429C19.5622 2.74269 19.5286 2.78346 19.4866 2.8365C19.4027 2.94255 19.2855 3.09773 19.1462 3.30117C18.8678 3.70798 18.5006 4.30841 18.1348 5.09551C17.4027 6.67071 16.6765 8.99234 16.6765 12L17.6765 12C17.6765 9.15766 18.362 6.97929 19.0417 5.51699C19.3817 4.78534 19.7205 4.23265 19.9714 3.86601C20.0969 3.68274 20.2003 3.54612 20.2708 3.45706C20.306 3.41253 20.333 3.37992 20.3504 3.35932C20.3591 3.34902 20.3654 3.34173 20.3691 3.33746C20.3709 3.33532 20.3721 3.33395 20.3727 3.33332C20.373 3.33301 20.3731 3.33289 20.373 3.33296C20.373 3.33299 20.3729 3.33307 20.3728 3.3332C20.3727 3.33327 20.3726 3.3334 20.3726 3.33343C20.3725 3.33358 20.3723 3.33373 20 3ZM16.6765 12C16.6765 15.0077 17.4027 17.3293 18.1348 18.9045C18.5006 19.6916 18.8678 20.292 19.1462 20.6988C19.2855 20.9023 19.4027 21.0575 19.4866 21.1635C19.5286 21.2165 19.5622 21.2573 19.5862 21.2857C19.5982 21.2999 19.6078 21.311 19.6147 21.319C19.6182 21.323 19.6211 21.3263 19.6232 21.3287C19.6243 21.3299 19.6252 21.331 19.626 21.3318C19.6263 21.3322 19.6267 21.3326 19.6269 21.3329C19.6271 21.3331 19.6273 21.3333 19.6273 21.3334C19.6275 21.3336 19.6277 21.3337 20 21C20.3723 20.6663 20.3725 20.6664 20.3726 20.6666C20.3726 20.6666 20.3727 20.6667 20.3728 20.6668C20.3729 20.6669 20.373 20.667 20.373 20.667C20.3731 20.6671 20.373 20.667 20.3727 20.6667C20.3721 20.6661 20.3709 20.6647 20.3691 20.6625C20.3654 20.6583 20.3591 20.651 20.3504 20.6407C20.333 20.6201 20.306 20.5875 20.2708 20.5429C20.2003 20.4539 20.0969 20.3173 19.9714 20.134C19.7205 19.7674 19.3817 19.2147 19.0417 18.483C18.362 17.0207 17.6765 14.8423 17.6765 12L16.6765 12Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 63 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="2.5 2.5 19 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.5 3C2.5 2.72386 2.72386 2.5 3 2.5H13C17.6944 2.5 21.5 6.30558 21.5 11V13C21.5 17.6944 17.6944 21.5 13 21.5H3C2.72386 21.5 2.5 21.2761 2.5 21V3ZM3.5 3.5V20.5H13C17.1421 20.5 20.5 17.1421 20.5 13V11C20.5 6.85786 17.1421 3.5 13 3.5H3.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 64 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M20 18L19.6002 17.6997L18.999 18.5H20V18ZM22 18H22.5V17.5H22V18ZM22 22V22.5H22.5V22H22ZM12 21.5C6.75329 21.5 2.5 17.2467 2.5 12H1.5C1.5 17.799 6.20101 22.5 12 22.5V21.5ZM2.5 12C2.5 6.75329 6.75329 2.5 12 2.5V1.5C6.20101 1.5 1.5 6.20101 1.5 12H2.5ZM12 2.5C17.2467 2.5 21.5 6.75329 21.5 12H22.5C22.5 6.20101 17.799 1.5 12 1.5V2.5ZM21.5 12C21.5 14.1393 20.793 16.1119 19.6002 17.6997L20.3998 18.3003C21.7181 16.5454 22.5 14.3635 22.5 12H21.5ZM20 18.5H22V17.5H20V18.5ZM21.5 18V22H22.5V18H21.5ZM22 21.5H12V22.5H22V21.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 65 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="3.5 1.5 17 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M4 5L3.55279 4.77639C3.51807 4.84582 3.5 4.92238 3.5 5H4ZM20 5H20.5C20.5 4.92238 20.4819 4.84582 20.4472 4.77639L20 5ZM4 19H3.5C3.5 19.0537 3.50866 19.1071 3.52566 19.1581L4 19ZM20 19L20.4743 19.1581C20.4913 19.1071 20.5 19.0537 20.5 19H20ZM12 21.5C8.56995 21.5 6.67417 20.7652 5.65235 20.084C5.14085 19.743 4.84007 19.4101 4.67096 19.176C4.58608 19.0585 4.53349 18.9646 4.50385 18.9053C4.48903 18.8756 4.47992 18.8546 4.47538 18.8436C4.47312 18.8381 4.47199 18.835 4.47187 18.8347C4.4718 18.8345 4.47199 18.835 4.47241 18.8362C4.47262 18.8368 4.47288 18.8376 4.47321 18.8385C4.47337 18.839 4.47354 18.8395 4.47373 18.8401C4.47383 18.8404 4.47398 18.8408 4.47403 18.8409C4.47418 18.8414 4.47434 18.8419 4 19C3.52566 19.1581 3.52582 19.1586 3.526 19.1591C3.52606 19.1593 3.52623 19.1598 3.52636 19.1602C3.52661 19.1609 3.52688 19.1617 3.52716 19.1626C3.52774 19.1642 3.52838 19.1661 3.5291 19.1681C3.53053 19.1722 3.53226 19.177 3.5343 19.1825C3.53838 19.1935 3.54373 19.2074 3.55049 19.2238C3.56402 19.2567 3.58324 19.3001 3.60943 19.3525C3.66183 19.4573 3.74205 19.5978 3.86029 19.7615C4.09743 20.0899 4.48415 20.507 5.09765 20.916C6.32583 21.7348 8.43005 22.5 12 22.5V21.5ZM4.5 19V5H3.5V19H4.5ZM19.5 5V19H20.5V5H19.5ZM20 19C19.5257 18.8419 19.5258 18.8414 19.526 18.8409C19.526 18.8408 19.5262 18.8404 19.5263 18.8401C19.5265 18.8395 19.5266 18.839 19.5268 18.8385C19.5271 18.8376 19.5274 18.8368 19.5276 18.8362C19.528 18.835 19.5282 18.8345 19.5281 18.8347C19.528 18.835 19.5269 18.8381 19.5246 18.8436C19.5201 18.8546 19.511 18.8756 19.4961 18.9053C19.4665 18.9646 19.4139 19.0585 19.329 19.176C19.1599 19.4101 18.8592 19.743 18.3476 20.084C17.3258 20.7652 15.4301 21.5 12 21.5V22.5C15.5699 22.5 17.6742 21.7348 18.9024 20.916C19.5158 20.507 19.9026 20.0899 20.1397 19.7615C20.258 19.5978 20.3382 19.4573 20.3906 19.3525C20.4168 19.3001 20.436 19.2567 20.4495 19.2238C20.4563 19.2074 20.4616 19.1935 20.4657 19.1825C20.4677 19.177 20.4695 19.1722 20.4709 19.1681C20.4716 19.1661 20.4723 19.1642 20.4728 19.1626C20.4731 19.1617 20.4734 19.1609 20.4736 19.1602C20.4738 19.1598 20.4739 19.1593 20.474 19.1591C20.4742 19.1586 20.4743 19.1581 20 19ZM4 5C4.44721 5.22361 4.44703 5.22397 4.44685 5.22433C4.4468 5.22443 4.44663 5.22478 4.44652 5.22499C4.44631 5.2254 4.44612 5.22577 4.44596 5.2261C4.44563 5.22675 4.44538 5.22722 4.44523 5.22752C4.44492 5.22812 4.44497 5.22802 4.44538 5.22724C4.44621 5.22569 4.44852 5.22143 4.45241 5.21464C4.46018 5.20106 4.47425 5.17737 4.49546 5.14499C4.53786 5.08023 4.60878 4.98066 4.71482 4.85751C4.92654 4.61164 5.27994 4.26983 5.8295 3.92274C6.92518 3.23073 8.82937 2.5 12 2.5V1.5C8.67063 1.5 6.57482 2.26927 5.2955 3.07726C4.65756 3.48017 4.22971 3.88836 3.95705 4.20499C3.82091 4.36309 3.72386 4.4979 3.65884 4.5972C3.62633 4.64685 3.60184 4.68761 3.58446 4.71798C3.57577 4.73316 3.56886 4.74575 3.56362 4.75555C3.561 4.76045 3.5588 4.76465 3.55699 4.76813C3.55609 4.76987 3.55529 4.77143 3.55459 4.77281C3.55424 4.7735 3.55392 4.77414 3.55362 4.77474C3.55347 4.77504 3.55326 4.77545 3.55318 4.7756C3.55298 4.776 3.55279 4.77639 4 5ZM12 2.5C15.1706 2.5 17.0748 3.23073 18.1705 3.92274C18.7201 4.26983 19.0735 4.61164 19.2852 4.85751C19.3912 4.98066 19.4621 5.08023 19.5045 5.14499C19.5257 5.17737 19.5398 5.20106 19.5476 5.21464C19.5515 5.22143 19.5538 5.22569 19.5546 5.22724C19.555 5.22802 19.5551 5.22812 19.5548 5.22752C19.5546 5.22722 19.5544 5.22675 19.554 5.2261C19.5539 5.22577 19.5537 5.2254 19.5535 5.22499C19.5534 5.22478 19.5532 5.22443 19.5531 5.22433C19.553 5.22397 19.5528 5.22361 20 5C20.4472 4.77639 20.447 4.776 20.4468 4.7756C20.4467 4.77545 20.4465 4.77504 20.4464 4.77474C20.4461 4.77414 20.4458 4.7735 20.4454 4.77281C20.4447 4.77143 20.4439 4.76987 20.443 4.76813C20.4412 4.76465 20.439 4.76045 20.4364 4.75555C20.4311 4.74575 20.4242 4.73316 20.4155 4.71798C20.3982 4.68761 20.3737 4.64685 20.3412 4.5972C20.2761 4.4979 20.1791 4.36309 20.0429 4.20499C19.7703 3.88836 19.3424 3.48017 18.7045 3.07726C17.4252 2.26927 15.3294 1.5 12 1.5V2.5ZM4 5C3.55279 5.22361 3.55298 5.224 3.55318 5.2244C3.55326 5.22455 3.55347 5.22496 3.55362 5.22526C3.55392 5.22586 3.55424 5.2265 3.55459 5.22719C3.55529 5.22857 3.55609 5.23013 3.55699 5.23187C3.5588 5.23535 3.561 5.23955 3.56362 5.24445C3.56886 5.25425 3.57577 5.26684 3.58446 5.28202C3.60184 5.31239 3.62633 5.35315 3.65884 5.4028C3.72386 5.5021 3.82091 5.63691 3.95705 5.79501C4.22971 6.11164 4.65756 6.51983 5.2955 6.92274C6.57482 7.73073 8.67063 8.5 12 8.5V7.5C8.82937 7.5 6.92518 6.76927 5.8295 6.07726C5.27994 5.73017 4.92654 5.38836 4.71482 5.14249C4.60878 5.01934 4.53786 4.91977 4.49546 4.85501C4.47425 4.82263 4.46018 4.79894 4.45241 4.78536C4.44852 4.77857 4.44621 4.77431 4.44538 4.77276C4.44497 4.77198 4.44492 4.77188 4.44523 4.77248C4.44538 4.77278 4.44563 4.77325 4.44596 4.7739C4.44612 4.77423 4.44631 4.7746 4.44652 4.77501C4.44663 4.77522 4.4468 4.77557 4.44685 4.77567C4.44703 4.77603 4.44721 4.77639 4 5ZM12 8.5C15.3294 8.5 17.4252 7.73073 18.7045 6.92274C19.3424 6.51983 19.7703 6.11164 20.0429 5.79501C20.1791 5.63691 20.2761 5.5021 20.3412 5.4028C20.3737 5.35315 20.3982 5.31239 20.4155 5.28202C20.4242 5.26684 20.4311 5.25425 20.4364 5.24445C20.439 5.23955 20.4412 5.23535 20.443 5.23187C20.4439 5.23013 20.4447 5.22857 20.4454 5.22719C20.4458 5.2265 20.4461 5.22586 20.4464 5.22526C20.4465 5.22496 20.4467 5.22455 20.4468 5.2244C20.447 5.224 20.4472 5.22361 20 5C19.5528 4.77639 19.553 4.77603 19.5531 4.77567C19.5532 4.77557 19.5534 4.77522 19.5535 4.77501C19.5537 4.7746 19.5539 4.77423 19.554 4.7739C19.5544 4.77325 19.5546 4.77278 19.5548 4.77248C19.5551 4.77188 19.555 4.77198 19.5546 4.77276C19.5538 4.77431 19.5515 4.77857 19.5476 4.78536C19.5398 4.79894 19.5257 4.82263 19.5045 4.85501C19.4621 4.91977 19.3912 5.01934 19.2852 5.14249C19.0735 5.38836 18.7201 5.73017 18.1705 6.07726C17.0748 6.76927 15.1706 7.5 12 7.5V8.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 66 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 3.5 21 17"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M19 4L19.2236 3.55279C19.1542 3.51807 19.0776 3.5 19 3.5L19 4ZM19 20L19 20.5C19.0776 20.5 19.1542 20.4819 19.2236 20.4472L19 20ZM5 4L5 3.5C4.94626 3.5 4.89287 3.50866 4.84189 3.52566L5 4ZM5 20L4.84189 20.4743C4.89287 20.4913 4.94626 20.5 5 20.5L5 20ZM2.5 12C2.5 8.56995 3.23482 6.67417 3.91603 5.65235C4.25703 5.14085 4.58985 4.84007 4.824 4.67096C4.94153 4.58608 5.03543 4.53349 5.0947 4.50385C5.12436 4.48903 5.14539 4.47992 5.15643 4.47538C5.16194 4.47312 5.16496 4.47199 5.1653 4.47186C5.16547 4.4718 5.16497 4.47199 5.16378 4.47241C5.16318 4.47262 5.16242 4.47288 5.16147 4.47321C5.161 4.47337 5.16049 4.47354 5.15993 4.47373C5.15965 4.47383 5.15919 4.47398 5.15905 4.47403C5.15859 4.47418 5.15811 4.47434 5 4C4.84189 3.52566 4.84139 3.52582 4.84088 3.52599C4.84069 3.52606 4.84017 3.52623 4.8398 3.52636C4.83906 3.52661 4.83827 3.52688 4.83743 3.52716C4.83576 3.52773 4.83391 3.52838 4.83187 3.52909C4.8278 3.53053 4.823 3.53226 4.81749 3.5343C4.80648 3.53838 4.79265 3.54373 4.77619 3.55049C4.74328 3.56402 4.69986 3.58324 4.64749 3.60943C4.54269 3.66182 4.40222 3.74205 4.2385 3.86028C3.91015 4.09743 3.49297 4.48415 3.08397 5.09765C2.26518 6.32583 1.5 8.43005 1.5 12L2.5 12ZM5 4.5L19 4.5L19 3.5L5 3.5L5 4.5ZM19 19.5L5 19.5L5 20.5L19 20.5L19 19.5ZM5 20C5.15811 19.5257 5.15859 19.5258 5.15905 19.526C5.15919 19.526 5.15965 19.5262 5.15992 19.5263C5.16049 19.5265 5.161 19.5266 5.16147 19.5268C5.16242 19.5271 5.16318 19.5274 5.16378 19.5276C5.16497 19.528 5.16547 19.5282 5.1653 19.5281C5.16496 19.528 5.16194 19.5269 5.15642 19.5246C5.14539 19.5201 5.12436 19.511 5.0947 19.4961C5.03543 19.4665 4.94153 19.4139 4.82399 19.329C4.58985 19.1599 4.25703 18.8592 3.91602 18.3476C3.23482 17.3258 2.5 15.4301 2.5 12L1.5 12C1.5 15.5699 2.26518 17.6742 3.08397 18.9023C3.49297 19.5158 3.91015 19.9026 4.2385 20.1397C4.40222 20.258 4.54269 20.3382 4.64749 20.3906C4.69986 20.4168 4.74328 20.436 4.77619 20.4495C4.79265 20.4563 4.80648 20.4616 4.81749 20.4657C4.823 20.4677 4.8278 20.4695 4.83187 20.4709C4.83391 20.4716 4.83576 20.4723 4.83743 20.4728C4.83827 20.4731 4.83906 20.4734 4.8398 20.4736C4.84017 20.4738 4.84069 20.4739 4.84088 20.474C4.84139 20.4742 4.84189 20.4743 5 20ZM19 4C18.7764 4.44721 18.776 4.44703 18.7757 4.44685C18.7756 4.4468 18.7752 4.44663 18.775 4.44652C18.7746 4.44631 18.7742 4.44612 18.7739 4.44596C18.7733 4.44563 18.7728 4.44538 18.7725 4.44523C18.7719 4.44492 18.772 4.44497 18.7728 4.44538C18.7743 4.44621 18.7786 4.44852 18.7854 4.45241C18.7989 4.46018 18.8226 4.47425 18.855 4.49546C18.9198 4.53786 19.0193 4.60878 19.1425 4.71482C19.3884 4.92654 19.7302 5.27994 20.0773 5.8295C20.7693 6.92518 21.5 8.82937 21.5 12L22.5 12C22.5 8.67063 21.7307 6.57482 20.9227 5.2955C20.5198 4.65756 20.1116 4.22971 19.795 3.95705C19.6369 3.82091 19.5021 3.72386 19.4028 3.65884C19.3532 3.62633 19.3124 3.60184 19.282 3.58446C19.2668 3.57577 19.2543 3.56886 19.2445 3.56362C19.2396 3.561 19.2354 3.5588 19.2319 3.55699C19.2301 3.55609 19.2286 3.55529 19.2272 3.55459C19.2265 3.55424 19.2259 3.55392 19.2253 3.55362C19.225 3.55347 19.2245 3.55326 19.2244 3.55318C19.224 3.55298 19.2236 3.55279 19 4ZM21.5 12C21.5 15.1706 20.7693 17.0748 20.0773 18.1705C19.7302 18.7201 19.3884 19.0735 19.1425 19.2852C19.0193 19.3912 18.9198 19.4621 18.855 19.5045C18.8226 19.5257 18.7989 19.5398 18.7854 19.5476C18.7786 19.5515 18.7743 19.5538 18.7728 19.5546C18.772 19.555 18.7719 19.5551 18.7725 19.5548C18.7728 19.5546 18.7733 19.5544 18.7739 19.554C18.7742 19.5539 18.7746 19.5537 18.775 19.5535C18.7752 19.5534 18.7756 19.5532 18.7757 19.5531C18.776 19.553 18.7764 19.5528 19 20C19.2236 20.4472 19.224 20.447 19.2244 20.4468C19.2245 20.4467 19.225 20.4465 19.2253 20.4464C19.2259 20.4461 19.2265 20.4458 19.2272 20.4454C19.2286 20.4447 19.2301 20.4439 19.2319 20.443C19.2354 20.4412 19.2396 20.439 19.2445 20.4364C19.2543 20.4311 19.2668 20.4242 19.282 20.4155C19.3124 20.3982 19.3532 20.3737 19.4028 20.3412C19.5021 20.2761 19.6369 20.1791 19.795 20.0429C20.1116 19.7703 20.5198 19.3424 20.9227 18.7045C21.7307 17.4252 22.5 15.3294 22.5 12L21.5 12ZM19 4C18.7764 3.55279 18.776 3.55298 18.7756 3.55318C18.7755 3.55326 18.775 3.55347 18.7747 3.55362C18.7741 3.55392 18.7735 3.55424 18.7728 3.55459C18.7714 3.55529 18.7699 3.55609 18.7681 3.55699C18.7646 3.5588 18.7604 3.561 18.7555 3.56362C18.7457 3.56886 18.7332 3.57577 18.718 3.58446C18.6876 3.60184 18.6468 3.62633 18.5972 3.65884C18.4979 3.72386 18.3631 3.82091 18.205 3.95705C17.8884 4.22971 17.4802 4.65756 17.0773 5.2955C16.2693 6.57482 15.5 8.67063 15.5 12L16.5 12C16.5 8.82937 17.2307 6.92518 17.9227 5.8295C18.2698 5.27994 18.6116 4.92654 18.8575 4.71482C18.9807 4.60878 19.0802 4.53786 19.145 4.49546C19.1774 4.47425 19.2011 4.46018 19.2146 4.45241C19.2214 4.44852 19.2257 4.44621 19.2272 4.44538C19.228 4.44497 19.2281 4.44492 19.2275 4.44523C19.2272 4.44538 19.2267 4.44563 19.2261 4.44596C19.2258 4.44612 19.2254 4.44631 19.225 4.44652C19.2248 4.44663 19.2244 4.4468 19.2243 4.44685C19.224 4.44703 19.2236 4.44721 19 4ZM15.5 12C15.5 15.3294 16.2693 17.4252 17.0773 18.7045C17.4802 19.3424 17.8884 19.7703 18.205 20.0429C18.3631 20.1791 18.4979 20.2761 18.5972 20.3412C18.6468 20.3737 18.6876 20.3982 18.718 20.4155C18.7332 20.4242 18.7457 20.4311 18.7555 20.4364C18.7604 20.439 18.7646 20.4412 18.7681 20.443C18.7699 20.4439 18.7714 20.4447 18.7728 20.4454C18.7735 20.4458 18.7741 20.4461 18.7747 20.4464C18.775 20.4465 18.7755 20.4467 18.7756 20.4468C18.776 20.447 18.7764 20.4472 19 20C19.2236 19.5528 19.224 19.553 19.2243 19.5531C19.2244 19.5532 19.2248 19.5534 19.225 19.5535C19.2254 19.5537 19.2258 19.5539 19.2261 19.554C19.2267 19.5544 19.2272 19.5546 19.2275 19.5548C19.2281 19.5551 19.228 19.555 19.2272 19.5546C19.2257 19.5538 19.2214 19.5515 19.2146 19.5476C19.2011 19.5398 19.1774 19.5257 19.145 19.5045C19.0802 19.4621 18.9807 19.3912 18.8575 19.2852C18.6116 19.0735 18.2698 18.7201 17.9227 18.1705C17.2307 17.0748 16.5 15.1706 16.5 12L15.5 12Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 67 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="0.5 2.5 23 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M7 3V2.5C6.83282 2.5 6.67671 2.58355 6.58397 2.72265L7 3ZM7 21L6.58397 21.2773C6.67671 21.4164 6.83282 21.5 7 21.5V21ZM1 12L0.583975 11.7226C0.472008 11.8906 0.472008 12.1094 0.583975 12.2774L1 12ZM7 3.5H19V2.5H7V3.5ZM22.5 7V17H23.5V7H22.5ZM19 20.5H7V21.5H19V20.5ZM7.41603 20.7227L1.41603 11.7226L0.583975 12.2774L6.58397 21.2773L7.41603 20.7227ZM1.41603 12.2774L7.41603 3.27735L6.58397 2.72265L0.583975 11.7226L1.41603 12.2774ZM22.5 17C22.5 18.933 20.933 20.5 19 20.5V21.5C21.4853 21.5 23.5 19.4853 23.5 17H22.5ZM19 3.5C20.933 3.5 22.5 5.067 22.5 7H23.5C23.5 4.51472 21.4853 2.5 19 2.5V3.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 69 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M2 16H1.5C1.5 16.2761 1.72386 16.5 2 16.5V16ZM2 8V7.5C1.72386 7.5 1.5 7.72386 1.5 8H2ZM11.5 8V8.5C11.7761 8.5 12 8.27614 12 8H11.5ZM11.5 2L11.8448 1.63793C11.7 1.49999 11.4869 1.46164 11.303 1.54043C11.1192 1.61922 11 1.79999 11 2H11.5ZM22 12L22.3448 12.3621C22.4439 12.2677 22.5 12.1368 22.5 12C22.5 11.8632 22.4439 11.7323 22.3448 11.6379L22 12ZM11.5 22H11C11 22.2 11.1192 22.3808 11.303 22.4596C11.4869 22.5384 11.7 22.5 11.8448 22.3621L11.5 22ZM11.5 16H12C12 15.7239 11.7761 15.5 11.5 15.5V16ZM2.5 16V8H1.5V16H2.5ZM12 8V2H11V8H12ZM11.1552 2.36207L21.6552 12.3621L22.3448 11.6379L11.8448 1.63793L11.1552 2.36207ZM21.6552 11.6379L11.1552 21.6379L11.8448 22.3621L22.3448 12.3621L21.6552 11.6379ZM2 8.5H11.5V7.5H2V8.5ZM12 22V16H11V22H12ZM11.5 15.5H2V16.5H11.5V15.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 70 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 16V16.5C22.2761 16.5 22.5 16.2761 22.5 16H22ZM22 8H22.5C22.5 7.72386 22.2761 7.5 22 7.5V8ZM12.5 8H12C12 8.27614 12.2239 8.5 12.5 8.5V8ZM12.5 2H13C13 1.79999 12.8808 1.61922 12.697 1.54043C12.5131 1.46164 12.3 1.49999 12.1552 1.63793L12.5 2ZM2 12L1.65517 11.6379C1.55608 11.7323 1.5 11.8632 1.5 12C1.5 12.1368 1.55608 12.2677 1.65517 12.3621L2 12ZM12.5 22L12.1552 22.3621C12.3 22.5 12.5131 22.5384 12.697 22.4596C12.8808 22.3808 13 22.2 13 22H12.5ZM12.5 16V15.5C12.2239 15.5 12 15.7239 12 16H12.5ZM22.5 16V8H21.5V16H22.5ZM13 8V2H12V8H13ZM12.1552 1.63793L1.65517 11.6379L2.34483 12.3621L12.8448 2.36207L12.1552 1.63793ZM1.65517 12.3621L12.1552 22.3621L12.8448 21.6379L2.34483 11.6379L1.65517 12.3621ZM22 7.5H12.5V8.5H22V7.5ZM13 22V16H12V22H13ZM12.5 16.5H22V15.5H12.5V16.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 71 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M16 22V22.5C16.2761 22.5 16.5 22.2761 16.5 22H16ZM8 22H7.5C7.5 22.2761 7.72386 22.5 8 22.5V22ZM8 12.5H8.5C8.5 12.2239 8.27614 12 8 12V12.5ZM2 12.5L1.63793 12.1552C1.49999 12.3 1.46164 12.5131 1.54043 12.697C1.61922 12.8808 1.79999 13 2 13V12.5ZM12 2L12.3621 1.65517C12.2677 1.55608 12.1368 1.5 12 1.5C11.8632 1.5 11.7323 1.55608 11.6379 1.65517L12 2ZM22 12.5V13C22.2 13 22.3808 12.8808 22.4596 12.697C22.5384 12.5131 22.5 12.3 22.3621 12.1552L22 12.5ZM16 12.5V12C15.7239 12 15.5 12.2239 15.5 12.5H16ZM16 21.5H8V22.5H16V21.5ZM8 12H2V13H8V12ZM2.36207 12.8448L12.3621 2.34483L11.6379 1.65517L1.63793 12.1552L2.36207 12.8448ZM11.6379 2.34483L21.6379 12.8448L22.3621 12.1552L12.3621 1.65517L11.6379 2.34483ZM8.5 22L8.5 12.5H7.5L7.5 22H8.5ZM22 12H16V13H22V12ZM15.5 12.5V22H16.5V12.5H15.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 72 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M8 2V1.5C7.72386 1.5 7.5 1.72386 7.5 2L8 2ZM16 2H16.5C16.5 1.72386 16.2761 1.5 16 1.5V2ZM16 11.5H15.5C15.5 11.7761 15.7239 12 16 12V11.5ZM22 11.5L22.3621 11.8448C22.5 11.7 22.5384 11.4869 22.4596 11.303C22.3808 11.1192 22.2 11 22 11V11.5ZM12 22L11.6379 22.3448C11.7323 22.4439 11.8632 22.5 12 22.5C12.1368 22.5 12.2677 22.4439 12.3621 22.3448L12 22ZM2 11.5L2 11C1.79999 11 1.61922 11.1192 1.54043 11.303C1.46164 11.4869 1.49999 11.7 1.63793 11.8448L2 11.5ZM8 11.5V12C8.13261 12 8.25979 11.9473 8.35355 11.8536C8.44732 11.7598 8.5 11.6326 8.5 11.5H8ZM8 2.5L16 2.5V1.5L8 1.5V2.5ZM16 12H22V11H16V12ZM21.6379 11.1552L11.6379 21.6552L12.3621 22.3448L22.3621 11.8448L21.6379 11.1552ZM12.3621 21.6552L2.36207 11.1552L1.63793 11.8448L11.6379 22.3448L12.3621 21.6552ZM15.5 2V11.5H16.5V2H15.5ZM2 12L8 12V11L2 11L2 12ZM8.5 11.5L8.5 2L7.5 2L7.5 11.5H8.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 73 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="0.5 4.5 23 16"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M8 15V14.5C7.72386 14.5 7.5 14.7239 7.5 15H8ZM8 10H7.5C7.5 10.2761 7.72386 10.5 8 10.5V10ZM16 10V10.5C16.2761 10.5 16.5 10.2761 16.5 10H16ZM16 5L16.3655 4.65884C16.2254 4.5087 16.0077 4.45952 15.8166 4.53483C15.6256 4.61014 15.5 4.79463 15.5 5H16ZM23 12.5L23.3655 12.8412C23.5448 12.6491 23.5448 12.3509 23.3655 12.1588L23 12.5ZM16 20H15.5C15.5 20.2054 15.6256 20.3899 15.8166 20.4652C16.0077 20.5405 16.2254 20.4913 16.3655 20.3412L16 20ZM16 15H16.5C16.5 14.7239 16.2761 14.5 16 14.5V15ZM1 12.5L0.634472 12.1588C0.455176 12.3509 0.455176 12.6491 0.634472 12.8412L1 12.5ZM8 5H8.5C8.5 4.79463 8.37442 4.61014 8.18335 4.53483C7.99229 4.45952 7.7746 4.5087 7.63447 4.65884L8 5ZM8 20L7.63447 20.3412C7.7746 20.4913 7.99229 20.5405 8.18335 20.4652C8.37442 20.3899 8.5 20.2054 8.5 20H8ZM16.5 10V5H15.5V10H16.5ZM15.6345 5.34116L22.6345 12.8412L23.3655 12.1588L16.3655 4.65884L15.6345 5.34116ZM22.6345 12.1588L15.6345 19.6588L16.3655 20.3412L23.3655 12.8412L22.6345 12.1588ZM8 10.5H16V9.5H8V10.5ZM16.5 20V15H15.5V20H16.5ZM16 14.5H8V15.5H16V14.5ZM1.36553 12.8412L8.36553 5.34116L7.63447 4.65884L0.634472 12.1588L1.36553 12.8412ZM7.5 5V10H8.5V5H7.5ZM7.5 15V20H8.5V15H7.5ZM8.36553 19.6588L1.36553 12.1588L0.634472 12.8412L7.63447 20.3412L8.36553 19.6588Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 74 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="4.0 0.5 16 23"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M14.5 16H14C14 16.2761 14.2239 16.5 14.5 16.5V16ZM9.5 16V16.5C9.63261 16.5 9.75979 16.4473 9.85355 16.3536C9.94732 16.2598 10 16.1326 10 16H9.5ZM9.5 8H10C10 7.86739 9.94732 7.74021 9.85355 7.64645C9.75979 7.55268 9.63261 7.5 9.5 7.5V8ZM4.5 8L4.15884 7.63447C4.0087 7.7746 3.95952 7.99229 4.03483 8.18335C4.11014 8.37442 4.29463 8.5 4.5 8.5L4.5 8ZM12 1L12.3412 0.634472C12.1491 0.455176 11.8509 0.455176 11.6588 0.634472L12 1ZM19.5 8V8.5C19.7054 8.5 19.8899 8.37442 19.9652 8.18335C20.0405 7.99229 19.9913 7.7746 19.8412 7.63447L19.5 8ZM14.5 8V7.5C14.2239 7.5 14 7.72386 14 8H14.5ZM12 23L11.6588 23.3655C11.8509 23.5448 12.1491 23.5448 12.3412 23.3655L12 23ZM4.5 16V15.5C4.29463 15.5 4.11014 15.6256 4.03483 15.8166C3.95952 16.0077 4.0087 16.2254 4.15884 16.3655L4.5 16ZM19.5 16L19.8412 16.3655C19.9913 16.2254 20.0405 16.0077 19.9652 15.8166C19.8899 15.6256 19.7054 15.5 19.5 15.5V16ZM9.5 7.5L4.5 7.5L4.5 8.5L9.5 8.5V7.5ZM4.84116 8.36553L12.3412 1.36553L11.6588 0.634472L4.15884 7.63447L4.84116 8.36553ZM11.6588 1.36553L19.1588 8.36553L19.8412 7.63447L12.3412 0.634472L11.6588 1.36553ZM10 16L10 8H9L9 16H10ZM19.5 7.5L14.5 7.5V8.5L19.5 8.5V7.5ZM14 8V16H15V8H14ZM12.3412 22.6345L4.84116 15.6345L4.15884 16.3655L11.6588 23.3655L12.3412 22.6345ZM4.5 16.5H9.5V15.5H4.5V16.5ZM14.5 16.5H19.5V15.5H14.5V16.5ZM19.1588 15.6345L11.6588 22.6345L12.3412 23.3655L19.8412 16.3655L19.1588 15.6345Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 75 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="0.5 0.5 23 23"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M10.5 5H11C11 4.72386 10.7761 4.5 10.5 4.5V5ZM6.5 5L6.20591 4.59563C6.03077 4.72301 5.95754 4.94867 6.02451 5.15462C6.09148 5.36058 6.28343 5.5 6.5 5.5V5ZM12 1L12.2941 0.595632C12.1188 0.468123 11.8812 0.468123 11.7059 0.595632L12 1ZM17.5 5V5.5C17.7166 5.5 17.9085 5.36058 17.9755 5.15462C18.0425 4.94867 17.9692 4.72301 17.7941 4.59563L17.5 5ZM13.5 5V4.5C13.2239 4.5 13 4.72386 13 5H13.5ZM12 23L11.7059 23.4044C11.8812 23.5319 12.1188 23.5319 12.2941 23.4044L12 23ZM6.5 19V18.5C6.28343 18.5 6.09148 18.6394 6.02451 18.8454C5.95754 19.0513 6.03077 19.277 6.20591 19.4044L6.5 19ZM10.5 19V19.5C10.7761 19.5 11 19.2761 11 19H10.5ZM13.5 19H13C13 19.2761 13.2239 19.5 13.5 19.5V19ZM17.5 19L17.7941 19.4044C17.9692 19.277 18.0425 19.0513 17.9755 18.8454C17.9085 18.6394 17.7166 18.5 17.5 18.5V19ZM19 10.5V11C19.2761 11 19.5 10.7761 19.5 10.5H19ZM19 6.5L19.4044 6.20591C19.277 6.03077 19.0513 5.95754 18.8454 6.02451C18.6394 6.09148 18.5 6.28343 18.5 6.5H19ZM23 12L23.4044 12.2941C23.5319 12.1188 23.5319 11.8812 23.4044 11.7059L23 12ZM19 17.5H18.5C18.5 17.7166 18.6394 17.9085 18.8454 17.9755C19.0513 18.0425 19.277 17.9692 19.4044 17.7941L19 17.5ZM19 13.5H19.5C19.5 13.3674 19.4473 13.2402 19.3536 13.1464C19.2598 13.0527 19.1326 13 19 13V13.5ZM1 12L0.595632 11.7059C0.468123 11.8812 0.468123 12.1188 0.595632 12.2941L1 12ZM5 6.5H5.5C5.5 6.28343 5.36058 6.09148 5.15462 6.02451C4.94867 5.95754 4.72301 6.03077 4.59563 6.20591L5 6.5ZM5 10.5H4.5C4.5 10.6326 4.55268 10.7598 4.64645 10.8536C4.74021 10.9473 4.86739 11 5 11V10.5ZM5 13.5V13C4.72386 13 4.5 13.2239 4.5 13.5H5ZM5 17.5L4.59563 17.7941C4.72301 17.9692 4.94867 18.0425 5.15462 17.9755C5.36058 17.9085 5.5 17.7166 5.5 17.5H5ZM10.5 4.5H6.5V5.5H10.5V4.5ZM6.79409 5.40437L12.2941 1.40437L11.7059 0.595632L6.20591 4.59563L6.79409 5.40437ZM11.7059 1.40437L17.2059 5.40437L17.7941 4.59563L12.2941 0.595632L11.7059 1.40437ZM17.5 4.5H13.5V5.5H17.5V4.5ZM12.2941 22.5956L6.79409 18.5956L6.20591 19.4044L11.7059 23.4044L12.2941 22.5956ZM6.5 19.5H10.5V18.5H6.5V19.5ZM13.5 19.5H17.5V18.5H13.5V19.5ZM17.2059 18.5956L11.7059 22.5956L12.2941 23.4044L17.7941 19.4044L17.2059 18.5956ZM11 10.5V5H10V10.5H11ZM11 19V13.5H10V19H11ZM13 5V10.5H14V5H13ZM13 13.5V19H14V13.5H13ZM19.5 10.5V6.5H18.5V10.5H19.5ZM18.5956 6.79409L22.5956 12.2941L23.4044 11.7059L19.4044 6.20591L18.5956 6.79409ZM22.5956 11.7059L18.5956 17.2059L19.4044 17.7941L23.4044 12.2941L22.5956 11.7059ZM19.5 17.5V13.5H18.5V17.5H19.5ZM1.40437 12.2941L5.40437 6.79409L4.59563 6.20591L0.595632 11.7059L1.40437 12.2941ZM4.5 6.5L4.5 10.5H5.5L5.5 6.5H4.5ZM4.5 13.5L4.5 17.5H5.5L5.5 13.5H4.5ZM5.40437 17.2059L1.40437 11.7059L0.595632 12.2941L4.59563 17.7941L5.40437 17.2059ZM11 13H5V14H11V13ZM19 13L13 13V14L19 14V13ZM5 11H11V10H5V11ZM13 11H19V10H13V11Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 76 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="0.5 2 23 20"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M10.5 6.52881H11C11 6.25267 10.7761 6.02881 10.5 6.02881V6.52881ZM6.5 6.52881L6.20453 6.12545C6.03008 6.25324 5.95755 6.4787 6.02477 6.68424C6.092 6.88978 6.28375 7.02881 6.5 7.02881V6.52881ZM12 2.5L12.2955 2.09664C12.1196 1.96779 11.8804 1.96779 11.7045 2.09664L12 2.5ZM17.5 6.52881V7.02881C17.7163 7.02881 17.908 6.88978 17.9752 6.68424C18.0425 6.4787 17.9699 6.25324 17.7955 6.12545L17.5 6.52881ZM13.5 6.52881V6.02881C13.2239 6.02881 13 6.25267 13 6.52881H13.5ZM13 17.5V18V17.5ZM19 14.5V15C19.2761 15 19.5 14.7761 19.5 14.5H19ZM19 10.5L19.4044 10.2059C19.277 10.0307 19.0513 9.95749 18.8454 10.0245C18.6394 10.0914 18.5 10.2834 18.5 10.5H19ZM23 16L23.4044 16.294C23.5319 16.1187 23.5319 15.8812 23.4044 15.7059L23 16ZM19 21.5H18.5C18.5 21.7165 18.6394 21.9085 18.8454 21.9755C19.0513 22.0424 19.277 21.9692 19.4044 21.794L19 21.5ZM19 17.5H19.5C19.5 17.3673 19.4473 17.2402 19.3536 17.1464C19.2598 17.0526 19.1326 17 19 17V17.5ZM1 16L0.595632 15.7059C0.468123 15.8812 0.468123 16.1187 0.595632 16.294L1 16ZM5 10.5H5.5C5.5 10.2834 5.36058 10.0914 5.15462 10.0245C4.94867 9.95749 4.72301 10.0307 4.59563 10.2059L5 10.5ZM5 14.5H4.5C4.5 14.6326 4.55268 14.7597 4.64645 14.8535C4.74021 14.9473 4.86739 15 5 15V14.5ZM5 17.5V17C4.86739 17 4.74021 17.0526 4.64645 17.1464C4.55268 17.2402 4.5 17.3673 4.5 17.5H5ZM5 21.5L4.59563 21.794C4.72301 21.9692 4.94867 22.0424 5.15462 21.9755C5.36058 21.9085 5.5 21.7165 5.5 21.5H5ZM10.5 6.02881H6.5V7.02881H10.5V6.02881ZM6.79547 6.93217L12.2955 2.90336L11.7045 2.09664L6.20453 6.12545L6.79547 6.93217ZM11.7045 2.90336L17.2045 6.93217L17.7955 6.12545L12.2955 2.09664L11.7045 2.90336ZM17.5 6.02881H13.5V7.02881H17.5V6.02881ZM11 14.5V6.52881H10V14.5H11ZM13 6.52881V14.5H14V6.52881H13ZM19.5 14.5V10.5H18.5V14.5H19.5ZM18.5956 10.794L22.5956 16.294L23.4044 15.7059L19.4044 10.2059L18.5956 10.794ZM22.5956 15.7059L18.5956 21.2059L19.4044 21.794L23.4044 16.294L22.5956 15.7059ZM19.5 21.5V17.5H18.5V21.5H19.5ZM1.40437 16.294L5.40437 10.794L4.59563 10.2059L0.595632 15.7059L1.40437 16.294ZM4.5 10.5L4.5 14.5H5.5L5.5 10.5H4.5ZM4.5 17.5L4.5 21.5H5.5L5.5 17.5H4.5ZM5.40437 21.2059L1.40437 15.7059L0.595632 16.294L4.59563 21.794L5.40437 21.2059ZM13 17L5 17V18L13 18V17ZM19 17L13 17V18L19 18V17ZM5 15H11V14H5V15ZM13 15H19V14H13V15Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 77 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="2.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M16 6V6.5C16.2761 6.5 16.5 6.27614 16.5 6H16ZM16 2L16.3402 1.6336C16.1945 1.49828 15.9824 1.46219 15.8001 1.54168C15.6179 1.62117 15.5 1.80113 15.5 2H16ZM23 8.5L23.3402 8.8664C23.4421 8.77179 23.5 8.63903 23.5 8.5C23.5 8.36097 23.4421 8.22821 23.3402 8.1336L23 8.5ZM16 15H15.5C15.5 15.1989 15.6179 15.3788 15.8001 15.4583C15.9824 15.5378 16.1945 15.5017 16.3402 15.3664L16 15ZM16 11H16.5C16.5 10.7239 16.2761 10.5 16 10.5V11ZM3 22H2.5C2.5 22.2754 2.72276 22.499 2.9982 22.5L3 22ZM8 22.018L7.9982 22.518C8.13112 22.5185 8.25876 22.466 8.35292 22.3722C8.44707 22.2784 8.5 22.1509 8.5 22.018H8ZM5.00018 7.5L5.33562 7.87079L5.00018 7.5ZM16.5 6V2H15.5V6H16.5ZM15.6598 2.3664L22.6598 8.8664L23.3402 8.1336L16.3402 1.6336L15.6598 2.3664ZM22.6598 8.1336L15.6598 14.6336L16.3402 15.3664L23.3402 8.8664L22.6598 8.1336ZM16.5 15V11H15.5V15H16.5ZM8.0018 21.518L3.0018 21.5L2.9982 22.5L7.9982 22.518L8.0018 21.518ZM16 10.5H11V11.5H16V10.5ZM8.5 22.018V14H7.5V22.018H8.5ZM8.5 14C8.5 13.58 8.63011 12.9389 9.00577 12.4172C9.36307 11.9209 9.96296 11.5 11 11.5V10.5C9.63704 10.5 8.73693 11.0791 8.19423 11.8328C7.66989 12.5611 7.5 13.42 7.5 14H8.5ZM3.5 22V12H2.5V22H3.5ZM3.5 12C3.5 11.5745 3.62693 10.8334 3.93211 10.0379C4.23617 9.24537 4.69908 8.44664 5.33562 7.87079L4.66475 7.12921C3.87514 7.84353 3.33796 8.7948 2.99846 9.67972C2.66008 10.5617 2.5 11.4255 2.5 12H3.5ZM5.33562 7.87079C6.05273 7.22206 6.61016 6.89698 7.261 6.71955C7.93609 6.53551 8.74409 6.5 10 6.5V5.5C8.75591 5.5 7.81987 5.5307 6.99798 5.75476C6.15184 5.98543 5.45937 6.41036 4.66475 7.12921L5.33562 7.87079ZM10 6.5H16V5.5H10V6.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 78 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="2.5 3.5 19.5 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M8 22.018L7.9982 22.518C8.13112 22.5185 8.25876 22.466 8.35292 22.3722C8.44707 22.2784 8.5 22.1509 8.5 22.018H8ZM3 22H2.5C2.5 22.2754 2.72276 22.499 2.9982 22.5L3 22ZM5.00018 5.5L5.33562 5.87079L5.00018 5.5ZM16.9998 5.5L16.6644 5.87079L16.9998 5.5ZM21.5 14L21.8841 14.3201C22.0083 14.1711 22.0351 13.9636 21.9528 13.7879C21.8705 13.6122 21.694 13.5 21.5 13.5V14ZM16.5 20L16.1159 20.3201C16.2109 20.4341 16.3516 20.5 16.5 20.5C16.6484 20.5 16.7891 20.4341 16.8841 20.3201L16.5 20ZM11.5 14V13.5C11.306 13.5 11.1295 13.6122 11.0472 13.7879C10.9649 13.9636 10.9917 14.1711 11.1159 14.3201L11.5 14ZM8.0018 21.518L3.0018 21.5L2.9982 22.5L7.9982 22.518L8.0018 21.518ZM8.5 22.018V12H7.5V22.018H8.5ZM8.5 12C8.5 11.58 8.63011 10.9389 9.00577 10.4172C9.36307 9.9209 9.96296 9.5 11 9.5V8.5C9.63704 8.5 8.73693 9.0791 8.19423 9.83285C7.66989 10.5611 7.5 11.42 7.5 12H8.5ZM3.5 22V10H2.5V22H3.5ZM3.5 10C3.5 9.57452 3.62693 8.83336 3.93211 8.03791C4.23617 7.24537 4.69908 6.44664 5.33562 5.87079L4.66475 5.12921C3.87514 5.84353 3.33796 6.7948 2.99846 7.67972C2.66008 8.56172 2.5 9.42548 2.5 10H3.5ZM5.33562 5.87079C6.05273 5.22206 6.61016 4.89698 7.261 4.71955C7.93609 4.53551 8.74409 4.5 10 4.5V3.5C8.75591 3.5 7.81987 3.5307 6.99798 3.75476C6.15184 3.98543 5.45937 4.41036 4.66475 5.12921L5.33562 5.87079ZM10 4.5H12V3.5H10V4.5ZM15 13.5H14.5V14.5H15V13.5ZM14.5 14C14.9962 14.0614 14.9962 14.0612 14.9963 14.061C14.9963 14.0609 14.9963 14.0606 14.9963 14.0604C14.9964 14.06 14.9964 14.0595 14.9965 14.0589C14.9967 14.0578 14.9968 14.0564 14.997 14.0546C14.9974 14.0511 14.998 14.0464 14.9986 14.0406C14.9999 14.0289 15.0016 14.0125 15.0036 13.9918C15.0076 13.9504 15.0127 13.8915 15.0175 13.8176C15.0271 13.6699 15.0357 13.4614 15.0323 13.212C15.0257 12.7165 14.9716 12.0437 14.7751 11.3616C14.5789 10.6804 14.232 9.96076 13.619 9.40948C12.9964 8.84952 12.1397 8.5 11 8.5V9.5C11.9199 9.5 12.5305 9.77548 12.9503 10.153C13.3797 10.5392 13.6503 11.0696 13.8142 11.6384C13.9778 12.2063 14.0265 12.7835 14.0324 13.2255C14.0354 13.4448 14.0278 13.6269 14.0196 13.7527C14.0155 13.8155 14.0113 13.8641 14.0083 13.8959C14.0067 13.9118 14.0055 13.9235 14.0047 13.9307C14.0043 13.9343 14.004 13.9368 14.0038 13.9381C14.0038 13.9388 14.0037 13.9392 14.0037 13.9392C14.0037 13.9393 14.0037 13.9392 14.0037 13.9391C14.0037 13.9391 14.0037 13.9389 14.0037 13.9389C14.0038 13.9387 14.0038 13.9386 14.5 14ZM19.5 14.5V10H18.5V14.5H19.5ZM19.5 10C19.5 8.37724 18.8792 6.52594 17.3353 5.12921L16.6644 5.87079C17.9728 7.0544 18.5 8.62276 18.5 10H19.5ZM17.3353 5.12921C16.5406 4.41036 15.8482 3.98543 15.002 3.75476C14.1801 3.5307 13.2441 3.5 12 3.5V4.5C13.2559 4.5 14.0639 4.53551 14.739 4.71955C15.3898 4.89698 15.9473 5.22206 16.6644 5.87079L17.3353 5.12921ZM19.5 14.5H21.5V13.5H19.5V14.5ZM21.1159 13.6799L16.1159 19.6799L16.8841 20.3201L21.8841 14.3201L21.1159 13.6799ZM16.8841 19.6799L11.8841 13.6799L11.1159 14.3201L16.1159 20.3201L16.8841 19.6799ZM11.5 14.5H14.5V13.5H11.5V14.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 79 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="0.5 0.5 23 23"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M1 17.5L0.623991 17.1704C0.453466 17.365 0.459512 17.6575 0.63793 17.8448L1 17.5ZM6.23807 11.5239H6.73807C6.73807 11.3156 6.60902 11.1292 6.41413 11.0559C6.21924 10.9826 5.99931 11.0377 5.86206 11.1943L6.23807 11.5239ZM6.23807 15.1904H5.73807C5.73807 15.4665 5.96192 15.6904 6.23807 15.6904V15.1904ZM6.23807 19.508V19.008C5.96192 19.008 5.73807 19.2318 5.73807 19.508H6.23807ZM6.23807 23L5.876 23.3448C6.017 23.4929 6.23393 23.5402 6.42376 23.4642C6.61359 23.3883 6.73807 23.2045 6.73807 23H6.23807ZM19.4916 19.508V20.008C19.7675 20.008 19.9913 19.7845 19.9916 19.5086L19.4916 19.508ZM19.508 6.23807V5.73807C19.2321 5.73807 19.0083 5.96155 19.008 6.23745L19.508 6.23807ZM15.0159 6.23807H15.5159C15.5159 5.96192 15.2921 5.73807 15.0159 5.73807V6.23807ZM11.5239 6.23807L11.1783 5.87675C11.0307 6.01793 10.9838 6.2347 11.0598 6.42426C11.1359 6.61383 11.3196 6.73807 11.5239 6.73807V6.23807ZM17 1L17.3288 0.623341C17.1339 0.453175 16.8414 0.459829 16.6544 0.63868L17 1ZM23 6.23807V6.73807C23.2084 6.73807 23.395 6.6088 23.4681 6.41367C23.5413 6.21853 23.4858 5.99847 23.3288 5.86141L23 6.23807ZM15.0159 15.1904V15.6904C15.2921 15.6904 15.5159 15.4665 15.5159 15.1904H15.0159ZM1.37601 17.8296L6.61407 11.8534L5.86206 11.1943L0.623991 17.1704L1.37601 17.8296ZM5.73807 11.5239V15.1904H6.73807V11.5239H5.73807ZM5.73807 19.508V23H6.73807V19.508H5.73807ZM6.60014 22.6552L1.36207 17.1552L0.63793 17.8448L5.876 23.3448L6.60014 22.6552ZM6.23807 20.008H19.4916V19.008H6.23807V20.008ZM19.9916 19.5086L20.008 6.23868L19.008 6.23745L18.9916 19.5073L19.9916 19.5086ZM15.0159 5.73807H11.5239V6.73807H15.0159V5.73807ZM11.8695 6.59939L17.3456 1.36132L16.6544 0.63868L11.1783 5.87675L11.8695 6.59939ZM16.6712 1.37666L22.6712 6.61473L23.3288 5.86141L17.3288 0.623341L16.6712 1.37666ZM23 5.73807H19.508V6.73807H23V5.73807ZM14.5159 6.23807V15.1904H15.5159V6.23807H14.5159ZM15.0159 14.6904H6.23807V15.6904H15.0159V14.6904Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 80 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="0.5 0.5 23 23"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M1 18.6904V18.1904C0.723858 18.1904 0.5 18.4142 0.5 18.6904H1ZM1 23H0.5C0.5 23.2761 0.723858 23.5 1 23.5V23ZM19.4916 23V23.5C19.7676 23.5 19.9914 23.2764 19.9916 23.0005L19.4916 23ZM19.5079 6.23807V5.73807C19.2319 5.73807 19.0081 5.96163 19.0079 6.23758L19.5079 6.23807ZM15.0158 6.23807L15.5158 6.23806C15.5158 5.96192 15.292 5.73807 15.0158 5.73807V6.23807ZM11.5238 6.23807L11.1782 5.87675C11.0306 6.01793 10.9837 6.2347 11.0597 6.42426C11.1358 6.61383 11.3195 6.73807 11.5238 6.73807V6.23807ZM16.9999 1L17.3287 0.623341C17.1338 0.453175 16.8413 0.459829 16.6543 0.63868L16.9999 1ZM22.9999 6.23807V6.73807C23.2083 6.73807 23.3949 6.6088 23.4681 6.41367C23.5413 6.21853 23.4857 5.99847 23.3287 5.86141L22.9999 6.23807ZM15.0159 18.6904V19.1904C15.1485 19.1904 15.2757 19.1377 15.3695 19.0439C15.4632 18.9502 15.5159 18.823 15.5159 18.6904L15.0159 18.6904ZM1.5 23V18.6904H0.5V23H1.5ZM1 23.5H19.4916V22.5H1V23.5ZM19.9916 23.0005L20.0079 6.23855L19.0079 6.23758L18.9916 22.9995L19.9916 23.0005ZM15.0158 5.73807H11.5238V6.73807H15.0158V5.73807ZM11.8694 6.59939L17.3455 1.36132L16.6543 0.63868L11.1782 5.87675L11.8694 6.59939ZM16.6711 1.37666L22.6711 6.61473L23.3287 5.86141L17.3287 0.623341L16.6711 1.37666ZM22.9999 5.73807H19.5079V6.73807H22.9999V5.73807ZM14.5158 6.23807L14.5159 18.6904L15.5159 18.6904L15.5158 6.23806L14.5158 6.23807ZM15.0159 18.1904H1V19.1904H15.0159V18.1904Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 81 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M6 16H5.5C5.5 16.2761 5.72386 16.5 6 16.5V16ZM6 8V7.5C5.72386 7.5 5.5 7.72386 5.5 8H6ZM12.5 8V8.5C12.7761 8.5 13 8.27614 13 8H12.5ZM12.5 2L12.8625 1.65563C12.7216 1.50731 12.5046 1.45979 12.3146 1.53565C12.1246 1.6115 12 1.79543 12 2H12.5ZM22 12L22.3625 12.3444C22.5458 12.1514 22.5458 11.8486 22.3625 11.6556L22 12ZM12.5 22H12C12 22.2046 12.1246 22.3885 12.3146 22.4644C12.5046 22.5402 12.7216 22.4927 12.8625 22.3444L12.5 22ZM12.5 16H13C13 15.7239 12.7761 15.5 12.5 15.5V16ZM4.5 8C4.5 7.72386 4.27614 7.5 4 7.5C3.72386 7.5 3.5 7.72386 3.5 8H4.5ZM3.5 16C3.5 16.2761 3.72386 16.5 4 16.5C4.27614 16.5 4.5 16.2761 4.5 16H3.5ZM2.5 8C2.5 7.72386 2.27614 7.5 2 7.5C1.72386 7.5 1.5 7.72386 1.5 8H2.5ZM1.5 16C1.5 16.2761 1.72386 16.5 2 16.5C2.27614 16.5 2.5 16.2761 2.5 16H1.5ZM6.5 16V8H5.5V16H6.5ZM13 8V2H12V8H13ZM12.1375 2.34437L21.6375 12.3444L22.3625 11.6556L12.8625 1.65563L12.1375 2.34437ZM21.6375 11.6556L12.1375 21.6556L12.8625 22.3444L22.3625 12.3444L21.6375 11.6556ZM6 8.5H12.5V7.5H6V8.5ZM13 22V16H12V22H13ZM12.5 15.5H6V16.5H12.5V15.5ZM3.5 8V16H4.5V8H3.5ZM1.5 8V16H2.5V8H1.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 82 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M2 16L1.62371 15.6707C1.49452 15.8184 1.46362 16.028 1.54468 16.2066C1.62575 16.3853 1.80381 16.5 2 16.5V16ZM2 8V7.5C1.80381 7.5 1.62575 7.61474 1.54468 7.79339C1.46362 7.97205 1.49452 8.18161 1.62371 8.32925L2 8ZM11.5 8V8.5C11.7761 8.5 12 8.27614 12 8H11.5ZM11.5 2L11.8448 1.63793C11.7 1.49999 11.4869 1.46164 11.303 1.54043C11.1192 1.61922 11 1.79999 11 2H11.5ZM22 12L22.3448 12.3621C22.4439 12.2677 22.5 12.1368 22.5 12C22.5 11.8632 22.4439 11.7323 22.3448 11.6379L22 12ZM11.5 22H11C11 22.2 11.1192 22.3808 11.303 22.4596C11.4869 22.5384 11.7 22.5 11.8448 22.3621L11.5 22ZM11.5 16H12C12 15.7239 11.7761 15.5 11.5 15.5V16ZM5.5 12L5.87629 12.3293C6.04124 12.1407 6.04124 11.8593 5.87629 11.6707L5.5 12ZM12 8V2H11V8H12ZM11.1552 2.36207L21.6552 12.3621L22.3448 11.6379L11.8448 1.63793L11.1552 2.36207ZM21.6552 11.6379L11.1552 21.6379L11.8448 22.3621L22.3448 12.3621L21.6552 11.6379ZM2 8.5H11.5V7.5H2V8.5ZM12 22V16H11V22H12ZM11.5 15.5H2V16.5H11.5V15.5ZM2.37629 16.3293L5.87629 12.3293L5.12371 11.6707L1.62371 15.6707L2.37629 16.3293ZM5.87629 11.6707L2.37629 7.67075L1.62371 8.32925L5.12371 12.3293L5.87629 11.6707Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 83 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 3.5 21 17"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M2 4V3.5C1.72386 3.5 1.5 3.72386 1.5 4H2ZM14.5 4L14.8648 3.65803C14.7702 3.5572 14.6382 3.5 14.5 3.5V4ZM22 12L22.3648 12.342C22.5451 12.1496 22.5451 11.8504 22.3648 11.658L22 12ZM14.5 20V20.5C14.6382 20.5 14.7702 20.4428 14.8648 20.342L14.5 20ZM2 20H1.5C1.5 20.2761 1.72386 20.5 2 20.5V20ZM2.5 16V8H1.5V16H2.5ZM2 4.5H14.5V3.5H2V4.5ZM14.1352 4.34197L21.6352 12.342L22.3648 11.658L14.8648 3.65803L14.1352 4.34197ZM21.6352 11.658L14.1352 19.658L14.8648 20.342L22.3648 12.342L21.6352 11.658ZM2.5 8V4H1.5V8H2.5ZM14.5 19.5H2V20.5H14.5V19.5ZM2.5 20V16H1.5V20H2.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 84 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="1.5 3.5 21 17"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M2 20L1.6 19.7C1.48637 19.8515 1.46809 20.0542 1.55279 20.2236C1.63748 20.393 1.81061 20.5 2 20.5V20ZM2 4V3.5C1.81061 3.5 1.63748 3.607 1.55279 3.77639C1.46809 3.94579 1.48637 4.14849 1.6 4.3L2 4ZM14.5 4L14.8648 3.65803C14.7702 3.5572 14.6382 3.5 14.5 3.5V4ZM22 12L22.3648 12.342C22.5451 12.1496 22.5451 11.8504 22.3648 11.658L22 12ZM14.5 20V20.5C14.6382 20.5 14.7702 20.4428 14.8648 20.342L14.5 20ZM8 12L8.4 12.3C8.53333 12.1222 8.53333 11.8778 8.4 11.7L8 12ZM2 4.5H14.5V3.5H2V4.5ZM14.5 19.5H2V20.5H14.5V19.5ZM2.4 20.3L8.4 12.3L7.6 11.7L1.6 19.7L2.4 20.3ZM8.4 11.7L2.4 3.7L1.6 4.3L7.6 12.3L8.4 11.7ZM21.6352 11.658L14.1352 19.658L14.8648 20.342L22.3648 12.342L21.6352 11.658ZM14.1352 4.34197L21.6352 12.342L22.3648 11.658L14.8648 3.65803L14.1352 4.34197Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 85 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="0.5 3.5 23 18"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M11 15V14.5C10.7239 14.5 10.5 14.7239 10.5 15H11ZM11 10H10.5C10.5 10.2761 10.7239 10.5 11 10.5V10ZM16 10V10.5C16.2761 10.5 16.5 10.2761 16.5 10H16ZM16 5L16.3655 4.65884C16.2254 4.5087 16.0077 4.45952 15.8166 4.53483C15.6256 4.61014 15.5 4.79463 15.5 5H16ZM23 12.5L23.3655 12.8412C23.5448 12.6491 23.5448 12.3509 23.3655 12.1588L23 12.5ZM16 20H15.5C15.5 20.2054 15.6256 20.3899 15.8166 20.4652C16.0077 20.5405 16.2254 20.4913 16.3655 20.3412L16 20ZM16 15H16.5C16.5 14.7239 16.2761 14.5 16 14.5V15ZM1 21H0.5C0.5 21.2761 0.723858 21.5 1 21.5V21ZM11 4H11.5C11.5 3.72386 11.2761 3.5 11 3.5V4ZM11 21V21.5C11.2761 21.5 11.5 21.2761 11.5 21H11ZM1 4V3.5C0.723858 3.5 0.5 3.72386 0.5 4H1ZM16.5 10V5H15.5V10H16.5ZM15.6345 5.34116L22.6345 12.8412L23.3655 12.1588L16.3655 4.65884L15.6345 5.34116ZM22.6345 12.1588L15.6345 19.6588L16.3655 20.3412L23.3655 12.8412L22.6345 12.1588ZM11 10.5H16V9.5H11V10.5ZM16.5 20V15H15.5V20H16.5ZM16 14.5H11V15.5H16V14.5ZM10.5 4V10H11.5V4H10.5ZM10.5 15V21H11.5V15H10.5ZM11 20.5H1V21.5H11V20.5ZM1.5 21V4H0.5V21H1.5ZM1 4.5H11V3.5H1V4.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 86 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="3 0.5 18 23"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M9.5 11H10C10 10.7239 9.77614 10.5 9.5 10.5V11ZM14.5 11V10.5C14.2239 10.5 14 10.7239 14 11H14.5ZM14.5 16H14C14 16.2761 14.2239 16.5 14.5 16.5V16ZM19.5 16L19.8412 16.3655C19.9913 16.2254 20.0405 16.0077 19.9652 15.8166C19.8899 15.6256 19.7054 15.5 19.5 15.5V16ZM12 23L11.6588 23.3655C11.8509 23.5448 12.1491 23.5448 12.3412 23.3655L12 23ZM4.5 16V15.5C4.29463 15.5 4.11014 15.6256 4.03483 15.8166C3.95952 16.0077 4.0087 16.2254 4.15884 16.3655L4.5 16ZM9.5 16V16.5C9.77614 16.5 10 16.2761 10 16H9.5ZM3.5 1L3.5 0.5C3.22386 0.5 3 0.723858 3 1L3.5 1ZM20.5 11V11.5C20.7761 11.5 21 11.2761 21 11H20.5ZM3.5 11H3C3 11.1326 3.05268 11.2598 3.14645 11.3536C3.24021 11.4473 3.36739 11.5 3.5 11.5V11ZM20.5 1H21C21 0.723858 20.7761 0.500001 20.5 0.500001V1ZM14.5 16.5H19.5V15.5H14.5V16.5ZM19.1588 15.6345L11.6588 22.6345L12.3412 23.3655L19.8412 16.3655L19.1588 15.6345ZM12.3412 22.6345L4.84116 15.6345L4.15884 16.3655L11.6588 23.3655L12.3412 22.6345ZM14 11V16H15V11H14ZM4.5 16.5H9.5V15.5H4.5V16.5ZM10 16V11H9V16H10ZM20.5 10.5H14.5V11.5H20.5V10.5ZM9.5 10.5H3.5V11.5H9.5V10.5ZM4 11L4 1L3 1L3 11H4ZM3.5 1.5L20.5 1.5V0.500001L3.5 0.5L3.5 1.5ZM20 1V11H21V1H20Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 87 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="0.5 3.5 23 18"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M13 15H13.5C13.5 14.7239 13.2761 14.5 13 14.5V15ZM13 10V10.5C13.2761 10.5 13.5 10.2761 13.5 10H13ZM8 10H7.5C7.5 10.2761 7.72386 10.5 8 10.5V10ZM8 5H8.5C8.5 4.79463 8.37442 4.61014 8.18335 4.53483C7.99229 4.45952 7.7746 4.5087 7.63447 4.65884L8 5ZM1 12.5L0.634472 12.1588C0.455176 12.3509 0.455176 12.6491 0.634472 12.8412L1 12.5ZM8 20L7.63447 20.3412C7.7746 20.4913 7.99229 20.5405 8.18335 20.4652C8.37442 20.3899 8.5 20.2054 8.5 20H8ZM8 15V14.5C7.72386 14.5 7.5 14.7239 7.5 15H8ZM23 21V21.5C23.2761 21.5 23.5 21.2761 23.5 21H23ZM13 4V3.5C12.7239 3.5 12.5 3.72386 12.5 4H13ZM13 21H12.5C12.5 21.2761 12.7239 21.5 13 21.5V21ZM23 4H23.5C23.5 3.72386 23.2761 3.5 23 3.5V4ZM8.5 10V5H7.5V10H8.5ZM7.63447 4.65884L0.634472 12.1588L1.36553 12.8412L8.36553 5.34116L7.63447 4.65884ZM0.634472 12.8412L7.63447 20.3412L8.36553 19.6588L1.36553 12.1588L0.634472 12.8412ZM13 9.5H8V10.5H13V9.5ZM8.5 20V15H7.5V20H8.5ZM8 15.5H13V14.5H8V15.5ZM12.5 4V10H13.5V4H12.5ZM12.5 15V21H13.5V15H12.5ZM13 21.5H23V20.5H13V21.5ZM23.5 21V4H22.5V21H23.5ZM23 3.5H13V4.5H23V3.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 88 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            viewBox="3 0.5 18 23"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M9.5 13V13.5C9.77614 13.5 10 13.2761 10 13H9.5ZM14.5 13H14C14 13.2761 14.2239 13.5 14.5 13.5V13ZM14.5 8V7.5C14.2239 7.5 14 7.72386 14 8H14.5ZM19.5 8V8.5C19.7054 8.5 19.8899 8.37442 19.9652 8.18335C20.0405 7.99229 19.9913 7.7746 19.8412 7.63447L19.5 8ZM12 1L12.3412 0.634472C12.1491 0.455176 11.8509 0.455176 11.6588 0.634472L12 1ZM4.5 8L4.15884 7.63447C4.0087 7.7746 3.95952 7.99229 4.03483 8.18335C4.11014 8.37442 4.29463 8.5 4.5 8.5V8ZM9.5 8H10C10 7.72386 9.77614 7.5 9.5 7.5V8ZM3.5 23H3C3 23.2761 3.22386 23.5 3.5 23.5V23ZM20.5 13H21C21 12.7239 20.7761 12.5 20.5 12.5V13ZM3.5 13V12.5C3.36739 12.5 3.24021 12.5527 3.14645 12.6464C3.05268 12.7402 3 12.8674 3 13H3.5ZM20.5 23V23.5C20.7761 23.5 21 23.2761 21 23H20.5ZM14.5 8.5H19.5V7.5H14.5V8.5ZM19.8412 7.63447L12.3412 0.634472L11.6588 1.36553L19.1588 8.36553L19.8412 7.63447ZM11.6588 0.634472L4.15884 7.63447L4.84116 8.36553L12.3412 1.36553L11.6588 0.634472ZM15 13V8H14V13H15ZM4.5 8.5H9.5V7.5H4.5V8.5ZM9 8V13H10V8H9ZM20.5 12.5H14.5V13.5H20.5V12.5ZM9.5 12.5H3.5V13.5H9.5V12.5ZM3 13L3 23H4L4 13H3ZM3.5 23.5H20.5V22.5H3.5V23.5ZM21 23V13H20V23H21Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}

        {this.props.shapeType === 89 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 2H2V17H4.5L8 22L12 17H22V2Z"
              stroke={this.state.borderColor}
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 90 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M14 17V16.5C13.8481 16.5 13.7045 16.569 13.6096 16.6877L14 17ZM10 22L9.59038 22.2867C9.68071 22.4158 9.82657 22.4947 9.984 22.4997C10.1414 22.5048 10.292 22.4353 10.3904 22.3123L10 22ZM6.5 17L6.90962 16.7133C6.81605 16.5796 6.66316 16.5 6.5 16.5V17ZM6 2.5H18V1.5H6V2.5ZM21.5 6V13H22.5V6H21.5ZM2.5 13V6H1.5V13H2.5ZM18 16.5H14V17.5H18V16.5ZM13.6096 16.6877L9.60957 21.6877L10.3904 22.3123L14.3904 17.3123L13.6096 16.6877ZM10.4096 21.7133L6.90962 16.7133L6.09038 17.2867L9.59038 22.2867L10.4096 21.7133ZM6.5 16.5H6V17.5H6.5V16.5ZM1.5 13C1.5 15.4853 3.51472 17.5 6 17.5V16.5C4.067 16.5 2.5 14.933 2.5 13H1.5ZM21.5 13C21.5 14.933 19.933 16.5 18 16.5V17.5C20.4853 17.5 22.5 15.4853 22.5 13H21.5ZM18 2.5C19.933 2.5 21.5 4.067 21.5 6H22.5C22.5 3.51472 20.4853 1.5 18 1.5V2.5ZM6 1.5C3.51472 1.5 1.5 3.51472 1.5 6H2.5C2.5 4.067 4.067 2.5 6 2.5V1.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 91 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1 0.5 22.5 22"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M4.00035 4.0001L3.62662 3.66795L4.00035 4.0001ZM21.0003 4.00018L20.624 4.32943L21.0003 4.00018ZM21.0003 14.5L20.6468 14.1464L21.0003 14.5ZM4.50035 17L4.90997 16.7133C4.88134 16.6724 4.84674 16.636 4.80733 16.6054L4.50035 17ZM12.0002 17L12.0211 16.5005C11.862 16.4938 11.7093 16.5633 11.6098 16.6877L12.0002 17ZM8.00022 22L7.5906 22.2868C7.68092 22.4158 7.82678 22.4947 7.98421 22.4998C8.14165 22.5048 8.29225 22.4354 8.39065 22.3124L8.00022 22ZM4.37408 4.33226C6.24178 2.23079 9.44927 1.25152 12.6782 1.31246C15.912 1.37349 19.0011 2.47457 20.624 4.32943L21.3766 3.67093C19.4995 1.52565 16.0883 0.376639 12.6971 0.312639C9.30091 0.248546 5.75844 1.26931 3.62662 3.66795L4.37408 4.33226ZM20.624 4.32943C23.1115 7.1724 23.4243 11.369 20.6468 14.1464L21.3538 14.8536C24.5766 11.631 24.1385 6.82753 21.3766 3.67093L20.624 4.32943ZM4.80733 16.6054C2.69594 14.9631 1.8629 12.7327 1.91435 10.4912C1.96615 8.23491 2.91677 5.97196 4.37408 4.33226L3.62662 3.66795C2.02147 5.474 0.972171 7.961 0.914618 10.4682C0.856725 12.9903 1.80491 15.5369 4.19337 17.3947L4.80733 16.6054ZM20.6468 14.1464C19.3868 15.4064 17.2775 16.0138 15.392 16.2908C14.4635 16.4272 13.6175 16.4797 13.0033 16.4979C12.6966 16.507 12.4488 16.5076 12.2787 16.5059C12.1936 16.505 12.128 16.5036 12.0843 16.5025C12.0625 16.5019 12.0461 16.5014 12.0354 16.501C12.0301 16.5008 12.0263 16.5007 12.0239 16.5006C12.0227 16.5005 12.0218 16.5005 12.0214 16.5005C12.0212 16.5005 12.021 16.5005 12.021 16.5005C12.021 16.5005 12.021 16.5005 12.021 16.5005C12.0211 16.5005 12.0211 16.5005 12.0002 17C11.9793 17.4996 11.9794 17.4996 11.9796 17.4996C11.9797 17.4996 11.9799 17.4996 11.98 17.4996C11.9804 17.4996 11.9808 17.4997 11.9813 17.4997C11.9824 17.4997 11.9838 17.4998 11.9856 17.4998C11.9893 17.5 11.9944 17.5002 12.001 17.5004C12.0141 17.5009 12.0331 17.5015 12.0576 17.5021C12.1066 17.5034 12.1778 17.5049 12.2687 17.5058C12.4505 17.5077 12.7116 17.507 13.033 17.4975C13.6749 17.4784 14.561 17.4237 15.5374 17.2802C17.4616 16.9975 19.8523 16.355 21.3538 14.8536L20.6468 14.1464ZM11.6098 16.6877L7.60978 21.6877L8.39065 22.3124L12.3907 17.3124L11.6098 16.6877ZM8.40984 21.7133L4.90997 16.7133L4.09073 17.2868L7.5906 22.2868L8.40984 21.7133Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 92 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="2 1.5 21.5 19.5"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M18.3059 6.02477L18.2626 6.52289C18.2862 6.52494 18.3098 6.52531 18.3335 6.52401L18.3059 6.02477ZM17.5466 6.02477L17.0608 6.14296C17.1191 6.38288 17.3439 6.54426 17.5899 6.52289L17.5466 6.02477ZM15.559 3.13104L15.8527 2.72636L15.8527 2.72635L15.559 3.13104ZM8.44109 3.13104L8.14744 2.72636L8.14744 2.72636L8.44109 3.13104ZM6.45353 6.02477L6.41025 6.52289C6.65623 6.54426 6.88098 6.38288 6.93935 6.14297L6.45353 6.02477ZM5.69417 6.02477L5.66662 6.52401C5.69023 6.52531 5.71389 6.52494 5.73745 6.52289L5.69417 6.02477ZM3.92006 6.25505L4.17398 6.68578L3.92006 6.25505ZM2.89044 7.57868L2.43951 7.36265L2.43951 7.36266L2.89044 7.57868ZM2.89044 10.7458L2.43951 10.9618L2.43951 10.9618L2.89044 10.7458ZM3.92011 12.0694L4.41084 11.9736C4.3891 11.8623 4.33014 11.7616 4.24364 11.6882L3.92011 12.0694ZM4.5 14L4.04947 14.2169L4.5 14ZM17 16V15.5C16.83 15.5 16.6716 15.5864 16.5796 15.7294L17 16ZM21.6073 12.9158L21.9308 13.2971L21.9308 13.297L21.6073 12.9158ZM22.6369 11.5922L22.186 11.3761L22.1859 11.3762L22.6369 11.5922ZM22.6369 8.42509L22.1859 8.64108L22.186 8.6412L22.6369 8.42509ZM21.6073 7.10147L21.9308 6.72028L21.9308 6.72028L21.6073 7.10147ZM4.50005 20.5L4.06644 20.251C3.9776 20.4058 3.97794 20.5961 4.06734 20.7505C4.15673 20.9049 4.32163 21 4.50005 21V20.5ZM6 16L6.49997 15.9945L6 16ZM6.00005 20.5V21C6.05917 21 6.11783 20.9895 6.17329 20.969L6.00005 20.5ZM11 17L11.2468 16.5651C11.036 16.4455 10.7698 16.4943 10.6151 16.6808L11 17ZM15 17.5L14.809 17.0379L15 17.5ZM9 19L8.70208 18.5985L9 19ZM18.3492 5.52664C18.0679 5.5022 17.7846 5.5022 17.5033 5.52664L17.5899 6.52289C17.8136 6.50345 18.0389 6.50345 18.2626 6.52289L18.3492 5.52664ZM18.0324 5.90657C17.725 4.64305 16.951 3.52337 15.8527 2.72636L15.2654 3.53572C16.1845 4.20269 16.8131 5.12493 17.0608 6.14296L18.0324 5.90657ZM15.8527 2.72635C14.7551 1.92991 13.3957 1.5 12 1.5V2.5C13.1934 2.5 14.3455 2.86821 15.2654 3.53572L15.8527 2.72635ZM12 1.5C10.6044 1.5 9.24501 1.92991 8.14744 2.72636L8.73474 3.53572C9.65464 2.86821 10.8066 2.5 12 2.5V1.5ZM8.14744 2.72636C7.04908 3.52337 6.27512 4.64305 5.9677 5.90656L6.93935 6.14297C7.18705 5.12492 7.8156 4.20269 8.73475 3.53572L8.14744 2.72636ZM6.4968 5.52664C6.21546 5.5022 5.93223 5.5022 5.6509 5.52664L5.73745 6.52289C5.96119 6.50345 6.1865 6.50345 6.41025 6.52289L6.4968 5.52664ZM5.72172 5.52553C5.18172 5.49573 4.42827 5.37503 3.66613 5.82433L4.17398 6.68578C4.61554 6.42547 5.00143 6.4873 5.66662 6.52401L5.72172 5.52553ZM3.66613 5.82433C2.95288 6.24482 2.67147 6.87849 2.43951 7.36265L3.34136 7.79471C3.58845 7.27895 3.75894 6.93046 4.17398 6.68578L3.66613 5.82433ZM2.43951 7.36266C2.16828 7.92883 2.02734 8.54144 2.02734 9.16225H3.02734C3.02734 8.69372 3.13354 8.2285 3.34136 7.79471L2.43951 7.36266ZM2.02734 9.16225C2.02734 9.78307 2.16828 10.3957 2.43951 10.9618L3.34136 10.5298C3.13354 10.096 3.02734 9.63079 3.02734 9.16225H2.02734ZM2.43951 10.9618C2.71064 11.5278 3.10546 12.0338 3.59659 12.4506L4.24364 11.6882C3.85531 11.3586 3.54928 10.9638 3.34136 10.5298L2.43951 10.9618ZM3.92011 12.0694C3.42938 12.1653 3.42939 12.1653 3.4294 12.1653C3.4294 12.1654 3.42941 12.1654 3.42942 12.1655C3.42944 12.1656 3.42946 12.1657 3.42949 12.1658C3.42953 12.166 3.4296 12.1664 3.42968 12.1668C3.42983 12.1676 3.43005 12.1687 3.43032 12.17C3.43087 12.1728 3.43165 12.1767 3.43265 12.1817C3.43466 12.1917 3.43758 12.2061 3.44137 12.2245C3.44896 12.2612 3.46007 12.3138 3.47444 12.379C3.50313 12.5091 3.54504 12.6901 3.59807 12.8944C3.70181 13.2939 3.85654 13.816 4.04947 14.2169L4.95053 13.7831C4.80204 13.4747 4.66683 13.0315 4.56598 12.6431C4.51672 12.4534 4.47767 12.2847 4.45098 12.1637C4.43765 12.1032 4.42747 12.0549 4.42068 12.0221C4.41729 12.0057 4.41475 11.9932 4.4131 11.9849C4.41227 11.9808 4.41167 11.9778 4.41129 11.9759C4.4111 11.9749 4.41097 11.9743 4.4109 11.9739C4.41086 11.9737 4.41084 11.9736 4.41083 11.9735C4.41082 11.9735 4.41082 11.9735 4.41083 11.9735C4.41083 11.9735 4.41083 11.9735 4.41083 11.9735C4.41084 11.9736 4.41084 11.9736 3.92011 12.0694ZM17 16.5C17.9181 16.5 18.5943 16.3663 19.0937 16.1275C19.6078 15.8817 19.9106 15.5356 20.089 15.1698C20.2559 14.8274 20.3061 14.4735 20.3424 14.2843C20.3523 14.233 20.3604 14.195 20.3683 14.1649C20.3722 14.1504 20.3754 14.1397 20.378 14.1321C20.3806 14.1244 20.3821 14.1213 20.382 14.1215C20.3798 14.1263 20.3389 14.2038 20.235 14.2376L19.9249 13.2869C19.6791 13.3671 19.5449 13.5493 19.4744 13.7017C19.4113 13.8381 19.3806 13.9901 19.3603 14.0959C19.3128 14.3436 19.2847 14.5375 19.1902 14.7315C19.107 14.9019 18.9651 15.0805 18.6623 15.2253C18.3448 15.3771 17.832 15.5 17 15.5V16.5ZM20.235 14.2376C20.8623 14.033 21.4398 13.7137 21.9308 13.2971L21.2837 12.5346C20.8954 12.8642 20.4332 13.1212 19.9249 13.2869L20.235 14.2376ZM21.9308 13.297C22.4218 12.8803 22.8167 12.3742 23.0878 11.8082L22.1859 11.3762C21.9781 11.8102 21.672 12.2051 21.2837 12.5346L21.9308 13.297ZM23.0877 11.8083C23.3591 11.2421 23.5 10.6295 23.5 10.0087H22.5C22.5 10.4772 22.3939 10.9424 22.186 11.3761L23.0877 11.8083ZM23.5 10.0087C23.5 9.38786 23.3591 8.77522 23.0877 8.20899L22.186 8.6412C22.3939 9.07493 22.5 9.54012 22.5 10.0087H23.5ZM23.0878 8.20911C22.8167 7.64311 22.4218 7.13707 21.9308 6.72028L21.2837 7.48265C21.672 7.81228 21.9781 8.20714 22.1859 8.64108L23.0878 8.20911ZM21.9308 6.72028C21.4398 6.30351 20.8622 5.98426 20.235 5.7797L19.9249 6.73041C20.4332 6.89618 20.8954 7.15303 21.2837 7.48266L21.9308 6.72028ZM20.235 5.7797C19.6077 5.57513 18.9421 5.4889 18.2784 5.52553L18.3335 6.52401C18.8749 6.49413 19.4166 6.56464 19.9249 6.73041L20.235 5.7797ZM4.04947 14.2169C4.31386 14.7661 4.78173 15.142 5.06976 15.403C5.40613 15.7079 5.49836 15.8527 5.50003 16.0055L6.49997 15.9945C6.49298 15.3543 6.04692 14.939 5.74131 14.662C5.38736 14.3413 5.10957 14.1136 4.95053 13.7831L4.04947 14.2169ZM5.50003 16.0055C5.50895 16.8217 5.17073 17.8656 4.79704 18.75C4.61423 19.1827 4.43044 19.56 4.2924 19.8291C4.22347 19.9634 4.16622 20.0703 4.12654 20.1429C4.10671 20.1792 4.09128 20.2069 4.08102 20.2252C4.07588 20.2344 4.07204 20.2412 4.06958 20.2455C4.06835 20.2477 4.06746 20.2492 4.06693 20.2502C4.06667 20.2506 4.0665 20.2509 4.06641 20.2511C4.06637 20.2512 4.06635 20.2512 4.06636 20.2512C4.06636 20.2512 4.06638 20.2511 4.06638 20.2511C4.0664 20.2511 4.06644 20.251 4.50005 20.5C4.93366 20.749 4.9337 20.7489 4.93375 20.7488C4.93378 20.7488 4.93383 20.7487 4.93388 20.7486C4.93397 20.7484 4.93409 20.7482 4.93424 20.748C4.93452 20.7475 4.9349 20.7468 4.93537 20.746C4.9363 20.7443 4.93759 20.7421 4.93924 20.7392C4.94253 20.7334 4.94722 20.7251 4.95322 20.7144C4.9652 20.693 4.98242 20.662 5.00412 20.6223C5.0475 20.5429 5.10885 20.4284 5.18213 20.2856C5.32848 20.0003 5.52348 19.6 5.71819 19.1392C6.09953 18.2367 6.51129 17.0306 6.49997 15.9945L5.50003 16.0055ZM4.50005 21H6.00005V20H4.50005V21ZM11 17C10.7532 17.4349 10.7534 17.4349 10.7535 17.435C10.7536 17.4351 10.7537 17.4352 10.7539 17.4352C10.7541 17.4354 10.7544 17.4355 10.7547 17.4357C10.7553 17.436 10.7561 17.4365 10.7569 17.437C10.7587 17.4379 10.761 17.4392 10.7639 17.4408C10.7695 17.444 10.7773 17.4482 10.7871 17.4535C10.8067 17.4641 10.8344 17.4789 10.8696 17.4969C10.94 17.533 11.0406 17.5826 11.1663 17.6391C11.417 17.7517 11.7714 17.8936 12.1877 18.0109C13.0057 18.2414 14.1367 18.3977 15.191 17.9621L14.809 17.0379C14.0587 17.348 13.1897 17.2543 12.4589 17.0484C12.1008 16.9475 11.7935 16.8246 11.5761 16.7269C11.4678 16.6782 11.3828 16.6363 11.3261 16.6072C11.2978 16.5927 11.2766 16.5814 11.2631 16.5741C11.2564 16.5705 11.2516 16.5678 11.2489 16.5663C11.2475 16.5655 11.2466 16.565 11.2463 16.5648C11.2461 16.5647 11.246 16.5647 11.2461 16.5648C11.2462 16.5648 11.2462 16.5648 11.2463 16.5649C11.2464 16.5649 11.2465 16.565 11.2465 16.565C11.2466 16.5651 11.2468 16.5651 11 17ZM15.191 17.9621C15.9593 17.6446 16.509 17.2338 16.8697 16.8971C17.05 16.7289 17.1833 16.579 17.2736 16.468C17.3188 16.4125 17.3533 16.3666 17.3776 16.3329C17.3897 16.316 17.3993 16.3022 17.4064 16.2917C17.41 16.2865 17.413 16.2821 17.4153 16.2785C17.4165 16.2768 17.4175 16.2752 17.4183 16.2739C17.4188 16.2732 17.4192 16.2726 17.4195 16.2721C17.4197 16.2718 17.4199 16.2716 17.42 16.2713C17.4201 16.2712 17.4202 16.271 17.4203 16.2709C17.4204 16.2708 17.4205 16.2706 17 16C16.5796 15.7294 16.5797 15.7292 16.5798 15.7291C16.5798 15.729 16.5799 15.7289 16.58 15.7288C16.5801 15.7286 16.5802 15.7284 16.5803 15.7282C16.5806 15.7279 16.5807 15.7276 16.5809 15.7274C16.5812 15.727 16.5813 15.7268 16.5813 15.7268C16.5813 15.7267 16.5808 15.7275 16.5797 15.7292C16.5775 15.7324 16.573 15.7389 16.5663 15.7482C16.5528 15.767 16.5301 15.7973 16.4979 15.8369C16.4334 15.9162 16.331 16.0321 16.1874 16.166C15.9005 16.4338 15.4501 16.773 14.809 17.0379L15.191 17.9621ZM6.00005 20.5C6.17329 20.969 6.17334 20.969 6.17339 20.969C6.17342 20.969 6.17349 20.969 6.17354 20.9689C6.17366 20.9689 6.1738 20.9688 6.17397 20.9688C6.17432 20.9686 6.17478 20.9685 6.17536 20.9683C6.17652 20.9678 6.17815 20.9672 6.18024 20.9664C6.18441 20.9649 6.1904 20.9627 6.19813 20.9597C6.2136 20.9539 6.23603 20.9454 6.26472 20.9345C6.32209 20.9125 6.40459 20.8804 6.50661 20.8396C6.71045 20.758 6.99332 20.641 7.31019 20.4989C7.93445 20.2189 8.72609 19.8258 9.29792 19.4015L8.70208 18.5985C8.22198 18.9546 7.51364 19.3116 6.90091 19.5865C6.59928 19.7218 6.3294 19.8334 6.13512 19.9112C6.03808 19.95 5.96016 19.9803 5.90689 20.0007C5.88026 20.0109 5.85981 20.0186 5.84623 20.0237C5.83944 20.0263 5.83437 20.0282 5.8311 20.0294C5.82947 20.03 5.82828 20.0304 5.82757 20.0307C5.82721 20.0308 5.82696 20.0309 5.82683 20.031C5.82677 20.031 5.82674 20.031 5.82673 20.031C5.82673 20.031 5.82675 20.031 5.82675 20.031C5.82677 20.031 5.8268 20.031 6.00005 20.5ZM9.29792 19.4015C9.78005 19.0438 10.3057 18.5157 10.6985 18.094C10.8979 17.88 11.0687 17.6872 11.1897 17.5478C11.2503 17.4781 11.2986 17.4215 11.332 17.3821C11.3487 17.3624 11.3616 17.347 11.3706 17.3363C11.375 17.331 11.3785 17.3269 11.3809 17.324C11.3821 17.3226 11.383 17.3214 11.3837 17.3206C11.384 17.3202 11.3843 17.3199 11.3845 17.3197C11.3846 17.3196 11.3846 17.3195 11.3847 17.3194C11.3847 17.3193 11.3848 17.3193 11.3848 17.3193C11.3848 17.3192 11.3849 17.3192 11 17C10.6151 16.6808 10.6152 16.6808 10.6152 16.6808C10.6152 16.6808 10.6152 16.6807 10.6152 16.6807C10.6152 16.6808 10.6152 16.6808 10.6151 16.6808C10.6151 16.6809 10.6149 16.6811 10.6147 16.6813C10.6143 16.6818 10.6136 16.6826 10.6127 16.6837C10.6108 16.686 10.6079 16.6895 10.604 16.6941C10.5962 16.7035 10.5844 16.7175 10.5689 16.7358C10.5379 16.7723 10.4924 16.8257 10.4348 16.8921C10.3194 17.0249 10.1565 17.2087 9.96679 17.4124C9.58138 17.8261 9.10703 18.298 8.70208 18.5985L9.29792 19.4015Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 93 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M22 11.2308C22 10.8227 21.8379 10.4314 21.5494 10.1429C21.2609 9.8544 20.8696 9.69231 20.4615 9.69231H14.3077V3.53846C14.3077 3.13044 14.1456 2.73912 13.8571 2.4506C13.5686 2.16209 13.1773 2 12.7692 2H11.2308C10.8227 2 10.4314 2.16209 10.1429 2.4506C9.8544 2.73912 9.69231 3.13044 9.69231 3.53846V9.69231H3.53846C3.13044 9.69231 2.73912 9.8544 2.4506 10.1429C2.16209 10.4314 2 10.8227 2 11.2308V12.7692C2 13.1773 2.16209 13.5686 2.4506 13.8571C2.73912 14.1456 3.13044 14.3077 3.53846 14.3077H9.69231V20.4615C9.69231 20.8696 9.8544 21.2609 10.1429 21.5494C10.4314 21.8379 10.8227 22 11.2308 22H12.7692C13.1773 22 13.5686 21.8379 13.8571 21.5494C14.1456 21.2609 14.3077 20.8696 14.3077 20.4615V14.3077H17.3846H20.4615C20.8696 14.3077 21.2609 14.1456 21.5494 13.8571C21.8379 13.5686 22 13.1773 22 12.7692V11.2308Z"
              stroke={this.state.borderColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 94 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M20.4615 9H3.53846C2.68879 9 2 9.74619 2 10.6667V12.3333C2 13.2538 2.68879 14 3.53846 14H20.4615C21.3112 14 22 13.2538 22 12.3333V10.6667C22 9.74619 21.3112 9 20.4615 9Z"
              stroke={this.state.borderColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 95 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M21.4541 5.90427C21.7547 5.60001 21.9233 5.18952 21.9233 4.7618C21.9233 4.33408 21.7547 3.9236 21.4541 3.61933L20.304 2.4692C20.0035 2.19113 19.6092 2.03666 19.1999 2.03666C18.7905 2.03666 18.3962 2.19113 18.0957 2.4692L11.9617 8.52659L5.90427 2.4692C5.60001 2.16858 5.18952 2 4.7618 2C4.33408 2 3.9236 2.16858 3.61933 2.4692L2.4692 3.61933C2.16858 3.9236 2 4.33408 2 4.7618C2 5.18952 2.16858 5.60001 2.4692 5.90427L8.60326 12.0383L2.4692 18.0957C2.16858 18.4 2 18.8105 2 19.2382C2 19.6659 2.16858 20.0764 2.4692 20.3807L3.61933 21.5308C3.9236 21.8314 4.33408 22 4.7618 22C5.18952 22 5.60001 21.8314 5.90427 21.5308L11.9617 15.3967L18.0957 21.4541C18.4 21.7547 18.8105 21.9233 19.2382 21.9233C19.6659 21.9233 20.0764 21.7547 20.3807 21.4541L21.5308 20.304C21.8314 19.9997 22 19.5892 22 19.1615C22 18.7338 21.8314 18.3233 21.5308 18.0191L15.3967 11.9617L21.4541 5.90427Z"
              stroke={this.state.borderColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 96 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1.5 2.5 21 18"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 3.5C11.1716 3.5 10.5 4.17157 10.5 5C10.5 5.82843 11.1716 6.5 12 6.5C12.8284 6.5 13.5 5.82843 13.5 5C13.5 4.17157 12.8284 3.5 12 3.5ZM9.5 5C9.5 3.61929 10.6193 2.5 12 2.5C13.3807 2.5 14.5 3.61929 14.5 5C14.5 6.38071 13.3807 7.5 12 7.5C10.6193 7.5 9.5 6.38071 9.5 5ZM3.53846 9.5C3.00186 9.5 2.5 9.9839 2.5 10.6667V12.3333C2.5 13.0161 3.00186 13.5 3.53846 13.5H20.4615C20.9981 13.5 21.5 13.0161 21.5 12.3333V10.6667C21.5 9.9839 20.9981 9.5 20.4615 9.5H3.53846ZM1.5 10.6667C1.5 9.50849 2.37572 8.5 3.53846 8.5H20.4615C21.6243 8.5 22.5 9.50849 22.5 10.6667V12.3333C22.5 13.4915 21.6243 14.5 20.4615 14.5H3.53846C2.37572 14.5 1.5 13.4915 1.5 12.3333V10.6667ZM10.5 18C10.5 17.1716 11.1716 16.5 12 16.5C12.8284 16.5 13.5 17.1716 13.5 18C13.5 18.8284 12.8284 19.5 12 19.5C11.1716 19.5 10.5 18.8284 10.5 18ZM12 15.5C10.6193 15.5 9.5 16.6193 9.5 18C9.5 19.3807 10.6193 20.5 12 20.5C13.3807 20.5 14.5 19.3807 14.5 18C14.5 16.6193 13.3807 15.5 12 15.5Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 97 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.5 6.66667C2.5 5.9839 3.00186 5.5 3.53846 5.5H20.4615C20.9981 5.5 21.5 5.9839 21.5 6.66667V8.33333C21.5 9.0161 20.9981 9.5 20.4615 9.5H3.53846C3.00186 9.5 2.5 9.0161 2.5 8.33333V6.66667ZM3.53846 4.5C2.37572 4.5 1.5 5.50849 1.5 6.66667V8.33333C1.5 9.49151 2.37572 10.5 3.53846 10.5H20.4615C21.6243 10.5 22.5 9.49151 22.5 8.33333V6.66667C22.5 5.50849 21.6243 4.5 20.4615 4.5H3.53846ZM2.5 15.6667C2.5 14.9839 3.00186 14.5 3.53846 14.5H20.4615C20.9981 14.5 21.5 14.9839 21.5 15.6667V17.3333C21.5 18.0161 20.9981 18.5 20.4615 18.5H3.53846C3.00186 18.5 2.5 18.0161 2.5 17.3333V15.6667ZM3.53846 13.5C2.37572 13.5 1.5 14.5085 1.5 15.6667V17.3333C1.5 18.4915 2.37572 19.5 3.53846 19.5H20.4615C21.6243 19.5 22.5 18.4915 22.5 17.3333V15.6667C22.5 14.5085 21.6243 13.5 20.4615 13.5H3.53846Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 98 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1.5 0.75 21 22.5"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M13.604 14H20.4615C21.3112 14 22 14.7462 22 15.6667V17.3333C22 18.2538 21.3112 19 20.4615 19H12L10.8024 21.6026C10.4828 22.4809 9.52245 22.9377 8.65749 22.6228L7.09134 22.0528C6.22637 21.738 5.78432 20.7708 6.10399 19.8925L6.5 19H3.53846C2.68879 19 2 18.2538 2 17.3333V15.6667C2 14.7462 2.68879 14 3.53846 14H8L8.651 12.4731L9.5 10H3.53846C2.68879 10 2 9.25381 2 8.33333V6.66667C2 5.74619 2.68879 5 3.53846 5H11.5L12.4708 2.39978C12.7905 1.52151 13.7508 1.06475 14.6158 1.37957L16.1819 1.9496C17.0469 2.26442 17.4889 3.23161 17.1693 4.10988L17 5H20.4615C21.3112 5 22 5.74619 22 6.66667V8.33333C22 9.25381 21.3112 10 20.4615 10H15L13.9506 12.9007L13.5 14"
              stroke={this.state.borderColor}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {this.props.shapeType === 99 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M6 2L4.69742 3.90621C4.24308 4.57111 4 5.35767 4 6.16297V17.837C4 18.6423 4.24307 19.4289 4.69742 20.0938L6 22"
              stroke={this.state.borderColor}
              strokeLinecap="round"
            />
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M18.4128 1.7179C18.257 1.48991 17.9459 1.43138 17.7179 1.58718C17.4899 1.74297 17.4314 2.0541 17.5872 2.2821L18.4128 1.7179ZM19.3282 3.94371L18.9154 4.2258L19.3282 3.94371ZM19.3282 20.0563L19.741 20.3384L19.3282 20.0563ZM17.5872 21.7179C17.4314 21.9459 17.4899 22.257 17.7179 22.4128C17.9459 22.5686 18.257 22.5101 18.4128 22.2821L17.5872 21.7179ZM17.5872 2.2821L18.9154 4.2258L19.741 3.66161L18.4128 1.7179L17.5872 2.2821ZM19.5 6.10839V17.8916H20.5V6.10839H19.5ZM18.9154 19.7742L17.5872 21.7179L18.4128 22.2821L19.741 20.3384L18.9154 19.7742ZM19.5 17.8916C19.5 18.5606 19.2971 19.2156 18.9154 19.7742L19.741 20.3384C20.2354 19.6149 20.5 18.7635 20.5 17.8916H19.5ZM18.9154 4.2258C19.2971 4.78443 19.5 5.43945 19.5 6.10839H20.5C20.5 5.23646 20.2354 4.38508 19.741 3.66161L18.9154 4.2258Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 100 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1.5 2.5 21 19"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M7.41282 2.2821C7.56862 2.0541 7.51009 1.74297 7.2821 1.58718C7.0541 1.43138 6.74297 1.48991 6.58718 1.7179L7.41282 2.2821ZM5.69742 3.90621L5.2846 3.62412L5.69742 3.90621ZM5.69742 20.0938L6.11024 19.8117L5.69742 20.0938ZM6.58718 22.2821C6.74297 22.5101 7.0541 22.5686 7.2821 22.4128C7.51009 22.257 7.56862 21.9459 7.41282 21.7179L6.58718 22.2821ZM3.85706 11.5486L4.07668 11.9978H4.07668L3.85706 11.5486ZM3.85706 12.4514L4.07668 12.0022H4.07668L3.85706 12.4514ZM6.58718 1.7179L5.2846 3.62412L6.11024 4.18831L7.41282 2.2821L6.58718 1.7179ZM5.2846 20.3759L6.58718 22.2821L7.41282 21.7179L6.11024 19.8117L5.2846 20.3759ZM4.5 6.16297V9.73234H5.5V6.16297H4.5ZM3.63744 11.0994C3.41252 11.2094 3.19376 11.3181 3.02984 11.4033C2.94893 11.4454 2.8753 11.4849 2.8194 11.5174C2.79308 11.5328 2.76029 11.5525 2.73005 11.5739C2.71673 11.5833 2.68892 11.6034 2.65951 11.6314C2.64547 11.6448 2.61745 11.6728 2.58952 11.7133C2.5703 11.7412 2.5 11.8458 2.5 12H3.5C3.5 12.1526 3.4305 12.2553 3.41285 12.2809C3.3865 12.3191 3.36083 12.3444 3.34989 12.3549C3.3267 12.377 3.30811 12.3899 3.30685 12.3907C3.30073 12.3951 3.30338 12.3928 3.32241 12.3817C3.3572 12.3615 3.41382 12.3308 3.49116 12.2906C3.64376 12.2112 3.85352 12.1069 4.07668 11.9978L3.63744 11.0994ZM2.5 12C2.5 12.1542 2.5703 12.2588 2.58952 12.2867C2.61745 12.3272 2.64547 12.3552 2.65951 12.3686C2.68892 12.3966 2.71673 12.4167 2.73005 12.4261C2.76029 12.4475 2.79308 12.4672 2.8194 12.4826C2.8753 12.5151 2.94893 12.5546 3.02984 12.5967C3.19376 12.6819 3.41252 12.7906 3.63744 12.9006L4.07668 12.0022C3.85352 11.8931 3.64376 11.7888 3.49116 11.7094C3.41382 11.6692 3.3572 11.6385 3.32241 11.6183C3.30338 11.6072 3.30073 11.6049 3.30685 11.6093C3.30811 11.6101 3.3267 11.623 3.34989 11.6451C3.36083 11.6556 3.3865 11.6809 3.41285 11.7191C3.4305 11.7447 3.5 11.8474 3.5 12H2.5ZM4.5 14.2677V17.837H5.5V14.2677H4.5ZM3.63744 12.9006C4.16485 13.1584 4.5 13.6888 4.5 14.2677H5.5C5.5 13.2986 4.9398 12.4242 4.07668 12.0022L3.63744 12.9006ZM4.5 9.73234C4.5 10.3112 4.16485 10.8416 3.63744 11.0994L4.07668 11.9978C4.9398 11.5758 5.5 10.7014 5.5 9.73234H4.5ZM6.11024 19.8117C5.71269 19.2299 5.5 18.5417 5.5 17.837H4.5C4.5 18.743 4.77346 19.6279 5.2846 20.3759L6.11024 19.8117ZM5.2846 3.62412C4.77346 4.37213 4.5 5.257 4.5 6.16297H5.5C5.5 5.45833 5.71269 4.77009 6.11024 4.18831L5.2846 3.62412Z"
              fill={this.state.borderColor}
            />
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M17.4128 1.7179C17.257 1.48991 16.9459 1.43138 16.7179 1.58718C16.4899 1.74297 16.4314 2.0541 16.5872 2.2821L17.4128 1.7179ZM18.3026 3.90621L18.7154 3.62412L18.3026 3.90621ZM18.3026 20.0938L17.8898 19.8117H17.8898L18.3026 20.0938ZM16.5872 21.7179C16.4314 21.9459 16.4899 22.257 16.7179 22.4128C16.9459 22.5686 17.257 22.5101 17.4128 22.2821L16.5872 21.7179ZM20.1429 11.5486L19.9233 11.9978H19.9233L20.1429 11.5486ZM20.1429 12.4514L19.9233 12.0022H19.9233L20.1429 12.4514ZM16.5872 2.2821L17.8898 4.18831L18.7154 3.62412L17.4128 1.7179L16.5872 2.2821ZM17.8898 19.8117L16.5872 21.7179L17.4128 22.2821L18.7154 20.3759L17.8898 19.8117ZM18.5 6.16297V9.73234H19.5V6.16297H18.5ZM19.9233 11.9978C20.1465 12.1069 20.3562 12.2112 20.5088 12.2906C20.5862 12.3308 20.6428 12.3615 20.6776 12.3817C20.6966 12.3928 20.6993 12.3951 20.6932 12.3907C20.6919 12.3899 20.6733 12.377 20.6501 12.3549C20.6392 12.3444 20.6135 12.3191 20.5871 12.2809C20.5695 12.2553 20.5 12.1526 20.5 12H21.5C21.5 11.8458 21.4297 11.7412 21.4105 11.7133C21.3825 11.6728 21.3545 11.6448 21.3405 11.6314C21.3111 11.6034 21.2833 11.5833 21.27 11.5739C21.2397 11.5525 21.2069 11.5328 21.1806 11.5174C21.1247 11.4849 21.0511 11.4454 20.9702 11.4033C20.8062 11.3181 20.5875 11.2094 20.3626 11.0994L19.9233 11.9978ZM20.5 12C20.5 11.8474 20.5695 11.7447 20.5871 11.7191C20.6135 11.6809 20.6392 11.6556 20.6501 11.6451C20.6733 11.623 20.6919 11.6101 20.6932 11.6093C20.6993 11.6049 20.6966 11.6072 20.6776 11.6183C20.6428 11.6385 20.5862 11.6692 20.5088 11.7094C20.3562 11.7888 20.1465 11.8931 19.9233 12.0022L20.3626 12.9006C20.5875 12.7906 20.8062 12.6819 20.9702 12.5967C21.0511 12.5546 21.1247 12.5151 21.1806 12.4826C21.2069 12.4672 21.2397 12.4475 21.27 12.4261C21.2833 12.4167 21.3111 12.3966 21.3405 12.3686C21.3545 12.3552 21.3825 12.3272 21.4105 12.2867C21.4297 12.2588 21.5 12.1542 21.5 12H20.5ZM18.5 14.2677V17.837H19.5V14.2677H18.5ZM19.9233 12.0022C19.0602 12.4242 18.5 13.2986 18.5 14.2677H19.5C19.5 13.6888 19.8351 13.1584 20.3626 12.9006L19.9233 12.0022ZM18.5 9.73234C18.5 10.7014 19.0602 11.5758 19.9233 11.9978L20.3626 11.0994C19.8351 10.8416 19.5 10.3112 19.5 9.73234H18.5ZM18.7154 20.3759C19.2265 19.6279 19.5 18.743 19.5 17.837H18.5C18.5 18.5417 18.2873 19.2299 17.8898 19.8117L18.7154 20.3759ZM17.8898 4.18831C18.2873 4.77009 18.5 5.45833 18.5 6.16297H19.5C19.5 5.257 19.2265 4.37213 18.7154 3.62412L17.8898 4.18831Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 101 && (
          <>
            <svg
              className={"shape"}
              preserveAspectRatio="none"
              onClick={this.props.onClick}
              viewBox="1.5 1.5 21 21"
              fill={this.state.backgroundColor}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeWidth={this.state.borderWeight}
                strokeDasharray={this.state.borderDashed}
                d="M13 2L11.6974 3.90621C11.2431 4.57111 11 5.35767 11 6.16297V17.837C11 18.6423 11.2431 19.4289 11.6974 20.0938L13 22"
                stroke={this.state.borderColor}
                strokeLinecap="round"
              />
            </svg>
          </>
        )}
        {this.props.shapeType === 102 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M11.4128 1.7179C11.257 1.48991 10.9459 1.43138 10.7179 1.58718C10.4899 1.74297 10.4314 2.0541 10.5872 2.2821L11.4128 1.7179ZM12.3282 3.94371L11.9154 4.2258L12.3282 3.94371ZM12.3282 20.0563L12.741 20.3384H12.741L12.3282 20.0563ZM10.5872 21.7179C10.4314 21.9459 10.4899 22.257 10.7179 22.4128C10.9459 22.5686 11.257 22.5101 11.4128 22.2821L10.5872 21.7179ZM10.5872 2.2821L11.9154 4.2258L12.741 3.66161L11.4128 1.7179L10.5872 2.2821ZM12.5 6.10839V17.8916H13.5V6.10839H12.5ZM11.9154 19.7742L10.5872 21.7179L11.4128 22.2821L12.741 20.3384L11.9154 19.7742ZM12.5 17.8916C12.5 18.5606 12.2971 19.2156 11.9154 19.7742L12.741 20.3384C13.2354 19.6149 13.5 18.7635 13.5 17.8916H12.5ZM11.9154 4.2258C12.2971 4.78443 12.5 5.43945 12.5 6.10839H13.5C13.5 5.23646 13.2354 4.38508 12.741 3.66161L11.9154 4.2258Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 103 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M14.4128 2.2821C14.5686 2.0541 14.5101 1.74297 14.2821 1.58718C14.0541 1.43138 13.743 1.48991 13.5872 1.7179L14.4128 2.2821ZM12.6974 3.90621L12.2846 3.62412L12.6974 3.90621ZM12.6974 20.0938L13.1102 19.8117L12.6974 20.0938ZM13.5872 22.2821C13.743 22.5101 14.0541 22.5686 14.2821 22.4128C14.5101 22.257 14.5686 21.9459 14.4128 21.7179L13.5872 22.2821ZM10.8571 11.5486L11.0767 11.9978H11.0767L10.8571 11.5486ZM10.8571 12.4514L11.0767 12.0022H11.0767L10.8571 12.4514ZM13.5872 1.7179L12.2846 3.62412L13.1102 4.18831L14.4128 2.2821L13.5872 1.7179ZM12.2846 20.3759L13.5872 22.2821L14.4128 21.7179L13.1102 19.8117L12.2846 20.3759ZM11.5 6.16297V9.73234H12.5V6.16297H11.5ZM10.6374 11.0994C10.4125 11.2094 10.1938 11.3181 10.0298 11.4033C9.94893 11.4454 9.8753 11.4849 9.8194 11.5174C9.79308 11.5328 9.76029 11.5525 9.73005 11.5739C9.71673 11.5833 9.68892 11.6034 9.65951 11.6314C9.64547 11.6448 9.61745 11.6728 9.58952 11.7133C9.5703 11.7412 9.5 11.8458 9.5 12H10.5C10.5 12.1526 10.4305 12.2553 10.4129 12.2809C10.3865 12.3191 10.3608 12.3444 10.3499 12.3549C10.3267 12.377 10.3081 12.3899 10.3068 12.3907C10.3007 12.3951 10.3034 12.3928 10.3224 12.3817C10.3572 12.3615 10.4138 12.3308 10.4912 12.2906C10.6438 12.2112 10.8535 12.1069 11.0767 11.9978L10.6374 11.0994ZM9.5 12C9.5 12.1542 9.5703 12.2588 9.58952 12.2867C9.61745 12.3272 9.64547 12.3552 9.65951 12.3686C9.68892 12.3966 9.71673 12.4167 9.73005 12.4261C9.76029 12.4475 9.79308 12.4672 9.8194 12.4826C9.8753 12.5151 9.94893 12.5546 10.0298 12.5967C10.1938 12.6819 10.4125 12.7906 10.6374 12.9006L11.0767 12.0022C10.8535 11.8931 10.6438 11.7888 10.4912 11.7094C10.4138 11.6692 10.3572 11.6385 10.3224 11.6183C10.3034 11.6072 10.3007 11.6049 10.3068 11.6093C10.3081 11.6101 10.3267 11.623 10.3499 11.6451C10.3608 11.6556 10.3865 11.6809 10.4129 11.7191C10.4305 11.7447 10.5 11.8474 10.5 12H9.5ZM11.5 14.2677V17.837H12.5V14.2677H11.5ZM10.6374 12.9006C11.1649 13.1584 11.5 13.6888 11.5 14.2677H12.5C12.5 13.2986 11.9398 12.4242 11.0767 12.0022L10.6374 12.9006ZM11.5 9.73234C11.5 10.3112 11.1649 10.8416 10.6374 11.0994L11.0767 11.9978C11.9398 11.5758 12.5 10.7014 12.5 9.73234H11.5ZM13.1102 19.8117C12.7127 19.2299 12.5 18.5417 12.5 17.837H11.5C11.5 18.743 11.7735 19.6279 12.2846 20.3759L13.1102 19.8117ZM12.2846 3.62412C11.7735 4.37213 11.5 5.257 11.5 6.16297H12.5C12.5 5.45833 12.7127 4.77009 13.1102 4.18831L12.2846 3.62412Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
        {this.props.shapeType === 104 && (
          <svg
            className={"shape"}
            preserveAspectRatio="none"
            onClick={this.props.onClick}
            width="24"
            height="24"
            viewBox="1.5 1.5 21 21"
            fill={this.state.backgroundColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeWidth={this.state.borderWeight}
              strokeDasharray={this.state.borderDashed}
              d="M10.4128 1.7179C10.257 1.48991 9.9459 1.43138 9.7179 1.58718C9.48991 1.74297 9.43138 2.0541 9.58718 2.2821L10.4128 1.7179ZM11.3026 3.90621L11.7154 3.62412L11.3026 3.90621ZM11.3026 20.0938L10.8898 19.8117H10.8898L11.3026 20.0938ZM9.58718 21.7179C9.43138 21.9459 9.48991 22.257 9.7179 22.4128C9.9459 22.5686 10.257 22.5101 10.4128 22.2821L9.58718 21.7179ZM13.1429 11.5486L12.9233 11.9978H12.9233L13.1429 11.5486ZM13.1429 12.4514L12.9233 12.0022H12.9233L13.1429 12.4514ZM9.58718 2.2821L10.8898 4.18831L11.7154 3.62412L10.4128 1.7179L9.58718 2.2821ZM10.8898 19.8117L9.58718 21.7179L10.4128 22.2821L11.7154 20.3759L10.8898 19.8117ZM11.5 6.16297V9.73234H12.5V6.16297H11.5ZM12.9233 11.9978C13.1465 12.1069 13.3562 12.2112 13.5088 12.2906C13.5862 12.3308 13.6428 12.3615 13.6776 12.3817C13.6966 12.3928 13.6993 12.3951 13.6932 12.3907C13.6919 12.3899 13.6733 12.377 13.6501 12.3549C13.6392 12.3444 13.6135 12.3191 13.5871 12.2809C13.5695 12.2553 13.5 12.1526 13.5 12H14.5C14.5 11.8458 14.4297 11.7412 14.4105 11.7133C14.3825 11.6728 14.3545 11.6448 14.3405 11.6314C14.3111 11.6034 14.2833 11.5833 14.27 11.5739C14.2397 11.5525 14.2069 11.5328 14.1806 11.5174C14.1247 11.4849 14.0511 11.4454 13.9702 11.4033C13.8062 11.3181 13.5875 11.2094 13.3626 11.0994L12.9233 11.9978ZM13.5 12C13.5 11.8474 13.5695 11.7447 13.5871 11.7191C13.6135 11.6809 13.6392 11.6556 13.6501 11.6451C13.6733 11.623 13.6919 11.6101 13.6932 11.6093C13.6993 11.6049 13.6966 11.6072 13.6776 11.6183C13.6428 11.6385 13.5862 11.6692 13.5088 11.7094C13.3562 11.7888 13.1465 11.8931 12.9233 12.0022L13.3626 12.9006C13.5875 12.7906 13.8062 12.6819 13.9702 12.5967C14.0511 12.5546 14.1247 12.5151 14.1806 12.4826C14.2069 12.4672 14.2397 12.4475 14.27 12.4261C14.2833 12.4167 14.3111 12.3966 14.3405 12.3686C14.3545 12.3552 14.3825 12.3272 14.4105 12.2867C14.4297 12.2588 14.5 12.1542 14.5 12H13.5ZM11.5 14.2677V17.837H12.5V14.2677H11.5ZM12.9233 12.0022C12.0602 12.4242 11.5 13.2986 11.5 14.2677H12.5C12.5 13.6888 12.8351 13.1584 13.3626 12.9006L12.9233 12.0022ZM11.5 9.73234C11.5 10.7014 12.0602 11.5758 12.9233 11.9978L13.3626 11.0994C12.8351 10.8416 12.5 10.3112 12.5 9.73234H11.5ZM11.7154 20.3759C12.2265 19.6279 12.5 18.743 12.5 17.837H11.5C11.5 18.5417 11.2873 19.2299 10.8898 19.8117L11.7154 20.3759ZM10.8898 4.18831C11.2873 4.77009 11.5 5.45833 11.5 6.16297H12.5C12.5 5.257 12.2265 4.37213 11.7154 3.62412L10.8898 4.18831Z"
              fill={this.state.borderColor}
            />
          </svg>
        )}
      </Fragment>
    );
  }
}

export default ShapeObject;
